module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "all-icons",
    attrs: {
      "id": "icons"
    }
  }, [_c('li', {
    staticClass: "ion-ionic",
    attrs: {
      "data-pack": "default",
      "data-tags": "badass, framework, sexy, hawt"
    }
  }, [_vm._v("ion-ionic")]), _c('li', {
    staticClass: "ion-arrow-up-a",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-up-a")]), _c('li', {
    staticClass: "ion-arrow-right-a",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-right-a")]), _c('li', {
    staticClass: "ion-arrow-down-a",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-down-a")]), _c('li', {
    staticClass: "ion-arrow-left-a",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-left-a")]), _c('li', {
    staticClass: "ion-arrow-up-b",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-up-b")]), _c('li', {
    staticClass: "ion-arrow-right-b",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-right-b")]), _c('li', {
    staticClass: "ion-arrow-down-b",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-down-b")]), _c('li', {
    staticClass: "ion-arrow-left-b",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-left-b")]), _c('li', {
    staticClass: "ion-arrow-up-c",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-up-c")]), _c('li', {
    staticClass: "ion-arrow-right-c",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-right-c")]), _c('li', {
    staticClass: "ion-arrow-down-c",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-down-c")]), _c('li', {
    staticClass: "ion-arrow-left-c",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-left-c")]), _c('li', {
    staticClass: "ion-arrow-return-right",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-return-right")]), _c('li', {
    staticClass: "ion-arrow-return-left",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-arrow-return-left")]), _c('li', {
    staticClass: "ion-arrow-swap",
    attrs: {
      "data-pack": "default",
      "data-tags": "switch, flip"
    }
  }, [_vm._v("ion-arrow-swap")]), _c('li', {
    staticClass: "ion-arrow-shrink",
    attrs: {
      "data-pack": "default",
      "data-tags": "pinch"
    }
  }, [_vm._v("ion-arrow-shrink")]), _c('li', {
    staticClass: "ion-arrow-expand",
    attrs: {
      "data-pack": "default",
      "data-tags": "fullscreen"
    }
  }, [_vm._v("ion-arrow-expand")]), _c('li', {
    staticClass: "ion-arrow-move",
    attrs: {
      "data-pack": "default",
      "data-tags": "drag"
    }
  }, [_vm._v("ion-arrow-move")]), _c('li', {
    staticClass: "ion-arrow-resize",
    attrs: {
      "data-pack": "default",
      "data-tags": "drag"
    }
  }, [_vm._v("ion-arrow-resize")]), _c('li', {
    staticClass: "ion-chevron-up",
    attrs: {
      "data-pack": "default",
      "data-tags": "arrow, up"
    }
  }, [_vm._v("ion-chevron-up")]), _c('li', {
    staticClass: "ion-chevron-right",
    attrs: {
      "data-pack": "default",
      "data-tags": "arrow, right"
    }
  }, [_vm._v("ion-chevron-right")]), _c('li', {
    staticClass: "ion-chevron-down",
    attrs: {
      "data-pack": "default",
      "data-tags": "arrow, down"
    }
  }, [_vm._v("ion-chevron-down")]), _c('li', {
    staticClass: "ion-chevron-left",
    attrs: {
      "data-pack": "default",
      "data-tags": "arrow, left"
    }
  }, [_vm._v("ion-chevron-left")]), _c('li', {
    staticClass: "ion-navicon-round",
    attrs: {
      "data-pack": "default",
      "data-tags": "menu, hamburger, slide menu"
    }
  }, [_vm._v("ion-navicon-round")]), _c('li', {
    staticClass: "ion-navicon",
    attrs: {
      "data-pack": "default",
      "data-tags": "menu, hamburger, slide menu"
    }
  }, [_vm._v("ion-navicon")]), _c('li', {
    staticClass: "ion-drag",
    attrs: {
      "data-pack": "default",
      "data-tags": "reorder, move, drag"
    }
  }, [_vm._v("ion-drag")]), _c('li', {
    staticClass: "ion-log-in",
    attrs: {
      "data-pack": "default",
      "data-tags": "sign in, "
    }
  }, [_vm._v("ion-log-in")]), _c('li', {
    staticClass: "ion-log-out",
    attrs: {
      "data-pack": "default",
      "data-tags": "sign out"
    }
  }, [_vm._v("ion-log-out")]), _c('li', {
    staticClass: "ion-checkmark-round",
    attrs: {
      "data-pack": "default",
      "data-tags": "complete, finished, success, on"
    }
  }, [_vm._v("ion-checkmark-round")]), _c('li', {
    staticClass: "ion-checkmark",
    attrs: {
      "data-pack": "default",
      "data-tags": "complete, finished, success, on"
    }
  }, [_vm._v("ion-checkmark")]), _c('li', {
    staticClass: "ion-checkmark-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "complete, finished, success, on"
    }
  }, [_vm._v("ion-checkmark-circled")]), _c('li', {
    staticClass: "ion-close-round",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, trash, kill, x"
    }
  }, [_vm._v("ion-close-round")]), _c('li', {
    staticClass: "ion-close",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, trash, kill, x"
    }
  }, [_vm._v("ion-close")]), _c('li', {
    staticClass: "ion-close-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, trash, kill, x"
    }
  }, [_vm._v("ion-close-circled")]), _c('li', {
    staticClass: "ion-plus-round",
    attrs: {
      "data-pack": "default",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-plus-round")]), _c('li', {
    staticClass: "ion-plus",
    attrs: {
      "data-pack": "default",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-plus")]), _c('li', {
    staticClass: "ion-plus-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-plus-circled")]), _c('li', {
    staticClass: "ion-minus-round",
    attrs: {
      "data-pack": "default",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-minus-round")]), _c('li', {
    staticClass: "ion-minus",
    attrs: {
      "data-pack": "default",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-minus")]), _c('li', {
    staticClass: "ion-minus-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-minus-circled")]), _c('li', {
    staticClass: "ion-information",
    attrs: {
      "data-pack": "default",
      "data-tags": "help, more, tooltip"
    }
  }, [_vm._v("ion-information")]), _c('li', {
    staticClass: "ion-information-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "help, more, tooltip"
    }
  }, [_vm._v("ion-information-circled")]), _c('li', {
    staticClass: "ion-help",
    attrs: {
      "data-pack": "default",
      "data-tags": "question, ?"
    }
  }, [_vm._v("ion-help")]), _c('li', {
    staticClass: "ion-help-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "question, ?"
    }
  }, [_vm._v("ion-help-circled")]), _c('li', {
    staticClass: "ion-backspace-outline",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, remove, back"
    }
  }, [_vm._v("ion-backspace-outline")]), _c('li', {
    staticClass: "ion-backspace",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, remove, back"
    }
  }, [_vm._v("ion-backspace")]), _c('li', {
    staticClass: "ion-help-buoy",
    attrs: {
      "data-pack": "default",
      "data-tags": "question, ?"
    }
  }, [_vm._v("ion-help-buoy")]), _c('li', {
    staticClass: "ion-asterisk",
    attrs: {
      "data-pack": "default",
      "data-tags": "favorite, mark, star"
    }
  }, [_vm._v("ion-asterisk")]), _c('li', {
    staticClass: "ion-alert",
    attrs: {
      "data-pack": "default",
      "data-tags": "attention, warning, notice, !, exclamation"
    }
  }, [_vm._v("ion-alert")]), _c('li', {
    staticClass: "ion-alert-circled",
    attrs: {
      "data-pack": "default",
      "data-tags": "attention, warning, notice, !, exclamation"
    }
  }, [_vm._v("ion-alert-circled")]), _c('li', {
    staticClass: "ion-refresh",
    attrs: {
      "data-pack": "default",
      "data-tags": "reload, renew"
    }
  }, [_vm._v("ion-refresh")]), _c('li', {
    staticClass: "ion-loop",
    attrs: {
      "data-pack": "default",
      "data-tags": "refresh"
    }
  }, [_vm._v("ion-loop")]), _c('li', {
    staticClass: "ion-shuffle",
    attrs: {
      "data-pack": "default",
      "data-tags": "random"
    }
  }, [_vm._v("ion-shuffle")]), _c('li', {
    staticClass: "ion-home",
    attrs: {
      "data-pack": "default",
      "data-tags": "house"
    }
  }, [_vm._v("ion-home")]), _c('li', {
    staticClass: "ion-search",
    attrs: {
      "data-pack": "default",
      "data-tags": "magnifying glass"
    }
  }, [_vm._v("ion-search")]), _c('li', {
    staticClass: "ion-flag",
    attrs: {
      "data-pack": "default",
      "data-tags": "favorite, mark, star"
    }
  }, [_vm._v("ion-flag")]), _c('li', {
    staticClass: "ion-star",
    attrs: {
      "data-pack": "default",
      "data-tags": "favorite"
    }
  }, [_vm._v("ion-star")]), _c('li', {
    staticClass: "ion-heart",
    attrs: {
      "data-pack": "default",
      "data-tags": "love"
    }
  }, [_vm._v("ion-heart")]), _c('li', {
    staticClass: "ion-heart-broken",
    attrs: {
      "data-pack": "default",
      "data-tags": "love"
    }
  }, [_vm._v("ion-heart-broken")]), _c('li', {
    staticClass: "ion-gear-a",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, cog"
    }
  }, [_vm._v("ion-gear-a")]), _c('li', {
    staticClass: "ion-gear-b",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, cog"
    }
  }, [_vm._v("ion-gear-b")]), _c('li', {
    staticClass: "ion-toggle-filled",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, switch"
    }
  }, [_vm._v("ion-toggle-filled")]), _c('li', {
    staticClass: "ion-toggle",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, switch"
    }
  }, [_vm._v("ion-toggle")]), _c('li', {
    staticClass: "ion-settings",
    attrs: {
      "data-pack": "default",
      "data-tags": "options, tools"
    }
  }, [_vm._v("ion-settings")]), _c('li', {
    staticClass: "ion-wrench",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, tools"
    }
  }, [_vm._v("ion-wrench")]), _c('li', {
    staticClass: "ion-hammer",
    attrs: {
      "data-pack": "default",
      "data-tags": "settings, options, tools"
    }
  }, [_vm._v("ion-hammer")]), _c('li', {
    staticClass: "ion-edit",
    attrs: {
      "data-pack": "default",
      "data-tags": "change, update, write, type, pencil"
    }
  }, [_vm._v("ion-edit")]), _c('li', {
    staticClass: "ion-trash-a",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, remove, dump"
    }
  }, [_vm._v("ion-trash-a")]), _c('li', {
    staticClass: "ion-trash-b",
    attrs: {
      "data-pack": "default",
      "data-tags": "delete, remove, dump"
    }
  }, [_vm._v("ion-trash-b")]), _c('li', {
    staticClass: "ion-document",
    attrs: {
      "data-pack": "default",
      "data-tags": "paper, file"
    }
  }, [_vm._v("ion-document")]), _c('li', {
    staticClass: "ion-document-text",
    attrs: {
      "data-pack": "default",
      "data-tags": "paper, file"
    }
  }, [_vm._v("ion-document-text")]), _c('li', {
    staticClass: "ion-clipboard",
    attrs: {
      "data-pack": "default",
      "data-tags": "write"
    }
  }, [_vm._v("ion-clipboard")]), _c('li', {
    staticClass: "ion-scissors",
    attrs: {
      "data-pack": "default",
      "data-tags": "cut"
    }
  }, [_vm._v("ion-scissors")]), _c('li', {
    staticClass: "ion-funnel",
    attrs: {
      "data-pack": "default",
      "data-tags": "sort"
    }
  }, [_vm._v("ion-funnel")]), _c('li', {
    staticClass: "ion-bookmark",
    attrs: {
      "data-pack": "default",
      "data-tags": "favorite, tag, save"
    }
  }, [_vm._v("ion-bookmark")]), _c('li', {
    staticClass: "ion-email",
    attrs: {
      "data-pack": "default",
      "data-tags": "snail, mail, inbox"
    }
  }, [_vm._v("ion-email")]), _c('li', {
    staticClass: "ion-email-unread",
    attrs: {
      "data-pack": "default",
      "data-tags": "snail, mail, inbox"
    }
  }, [_vm._v("ion-email-unread")]), _c('li', {
    staticClass: "ion-folder",
    attrs: {
      "data-pack": "default",
      "data-tags": "snail, mail"
    }
  }, [_vm._v("ion-folder")]), _c('li', {
    staticClass: "ion-filing",
    attrs: {
      "data-pack": "default",
      "data-tags": "mail"
    }
  }, [_vm._v("ion-filing")]), _c('li', {
    staticClass: "ion-archive",
    attrs: {
      "data-pack": "default",
      "data-tags": "mail"
    }
  }, [_vm._v("ion-archive")]), _c('li', {
    staticClass: "ion-reply",
    attrs: {
      "data-pack": "default",
      "data-tags": "mail, undo"
    }
  }, [_vm._v("ion-reply")]), _c('li', {
    staticClass: "ion-reply-all",
    attrs: {
      "data-pack": "default",
      "data-tags": "mail"
    }
  }, [_vm._v("ion-reply-all")]), _c('li', {
    staticClass: "ion-forward",
    attrs: {
      "data-pack": "default",
      "data-tags": "mail, redo"
    }
  }, [_vm._v("ion-forward")]), _c('li', {
    staticClass: "ion-share",
    attrs: {
      "data-pack": "default",
      "data-tags": "outbound"
    }
  }, [_vm._v("ion-share")]), _c('li', {
    staticClass: "ion-paper-airplane",
    attrs: {
      "data-pack": "default",
      "data-tags": "outbound, mail, letter, send"
    }
  }, [_vm._v("ion-paper-airplane")]), _c('li', {
    staticClass: "ion-link",
    attrs: {
      "data-pack": "default",
      "data-tags": "chain, anchor, href, attach"
    }
  }, [_vm._v("ion-link")]), _c('li', {
    staticClass: "ion-paperclip",
    attrs: {
      "data-pack": "default",
      "data-tags": "attach"
    }
  }, [_vm._v("ion-paperclip")]), _c('li', {
    staticClass: "ion-compose",
    attrs: {
      "data-pack": "default",
      "data-tags": "write, compose, type"
    }
  }, [_vm._v("ion-compose")]), _c('li', {
    staticClass: "ion-briefcase",
    attrs: {
      "data-pack": "default",
      "data-tags": "store, organize"
    }
  }, [_vm._v("ion-briefcase")]), _c('li', {
    staticClass: "ion-medkit",
    attrs: {
      "data-pack": "default",
      "data-tags": "health"
    }
  }, [_vm._v("ion-medkit")]), _c('li', {
    staticClass: "ion-at",
    attrs: {
      "data-pack": "default",
      "data-tags": "@"
    }
  }, [_vm._v("ion-at")]), _c('li', {
    staticClass: "ion-pound",
    attrs: {
      "data-pack": "default",
      "data-tags": "hashtag, #"
    }
  }, [_vm._v("ion-pound")]), _c('li', {
    staticClass: "ion-quote",
    attrs: {
      "data-pack": "default",
      "data-tags": "chat, quotation"
    }
  }, [_vm._v("ion-quote")]), _c('li', {
    staticClass: "ion-cloud",
    attrs: {
      "data-pack": "default",
      "data-tags": "storage"
    }
  }, [_vm._v("ion-cloud")]), _c('li', {
    staticClass: "ion-upload",
    attrs: {
      "data-pack": "default",
      "data-tags": "storage, cloud"
    }
  }, [_vm._v("ion-upload")]), _c('li', {
    staticClass: "ion-more",
    attrs: {
      "data-pack": "default",
      "data-tags": "circles"
    }
  }, [_vm._v("ion-more")]), _c('li', {
    staticClass: "ion-grid",
    attrs: {
      "data-pack": "default",
      "data-tags": "menu"
    }
  }, [_vm._v("ion-grid")]), _c('li', {
    staticClass: "ion-calendar",
    attrs: {
      "data-pack": "default",
      "data-tags": "date, time, month, year"
    }
  }, [_vm._v("ion-calendar")]), _c('li', {
    staticClass: "ion-clock",
    attrs: {
      "data-pack": "default",
      "data-tags": "time, watch, hours, minutes, seconds"
    }
  }, [_vm._v("ion-clock")]), _c('li', {
    staticClass: "ion-compass",
    attrs: {
      "data-pack": "default",
      "data-tags": "location, directions, navigation"
    }
  }, [_vm._v("ion-compass")]), _c('li', {
    staticClass: "ion-pinpoint",
    attrs: {
      "data-pack": "default",
      "data-tags": "gps, navigation"
    }
  }, [_vm._v("ion-pinpoint")]), _c('li', {
    staticClass: "ion-pin",
    attrs: {
      "data-pack": "default",
      "data-tags": "gps, navigation"
    }
  }, [_vm._v("ion-pin")]), _c('li', {
    staticClass: "ion-navigate",
    attrs: {
      "data-pack": "default",
      "data-tags": "gps, location pin"
    }
  }, [_vm._v("ion-navigate")]), _c('li', {
    staticClass: "ion-location",
    attrs: {
      "data-pack": "default",
      "data-tags": "gps, navigation, pin"
    }
  }, [_vm._v("ion-location")]), _c('li', {
    staticClass: "ion-map",
    attrs: {
      "data-pack": "default",
      "data-tags": "gps, navigation, pin"
    }
  }, [_vm._v("ion-map")]), _c('li', {
    staticClass: "ion-lock-combination",
    attrs: {
      "data-pack": "default",
      "data-tags": "padlock, security"
    }
  }, [_vm._v("ion-lock-combination")]), _c('li', {
    staticClass: "ion-locked",
    attrs: {
      "data-pack": "default",
      "data-tags": "padlock, security"
    }
  }, [_vm._v("ion-locked")]), _c('li', {
    staticClass: "ion-unlocked",
    attrs: {
      "data-pack": "default",
      "data-tags": "padlock, security"
    }
  }, [_vm._v("ion-unlocked")]), _c('li', {
    staticClass: "ion-key",
    attrs: {
      "data-pack": "default",
      "data-tags": "access"
    }
  }, [_vm._v("ion-key")]), _c('li', {
    staticClass: "ion-arrow-graph-up-right",
    attrs: {
      "data-pack": "default",
      "data-tags": "stats"
    }
  }, [_vm._v("ion-arrow-graph-up-right")]), _c('li', {
    staticClass: "ion-arrow-graph-down-right",
    attrs: {
      "data-pack": "default",
      "data-tags": "stats"
    }
  }, [_vm._v("ion-arrow-graph-down-right")]), _c('li', {
    staticClass: "ion-arrow-graph-up-left",
    attrs: {
      "data-pack": "default",
      "data-tags": "stats"
    }
  }, [_vm._v("ion-arrow-graph-up-left")]), _c('li', {
    staticClass: "ion-arrow-graph-down-left",
    attrs: {
      "data-pack": "default",
      "data-tags": "stats"
    }
  }, [_vm._v("ion-arrow-graph-down-left")]), _c('li', {
    staticClass: "ion-stats-bars",
    attrs: {
      "data-pack": "default",
      "data-tags": "data"
    }
  }, [_vm._v("ion-stats-bars")]), _c('li', {
    staticClass: "ion-connection-bars",
    attrs: {
      "data-pack": "default",
      "data-tags": "data, stats"
    }
  }, [_vm._v("ion-connection-bars")]), _c('li', {
    staticClass: "ion-pie-graph",
    attrs: {
      "data-pack": "default",
      "data-tags": "stats"
    }
  }, [_vm._v("ion-pie-graph")]), _c('li', {
    staticClass: "ion-chatbubble",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatbubble")]), _c('li', {
    staticClass: "ion-chatbubble-working",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatbubble-working")]), _c('li', {
    staticClass: "ion-chatbubbles",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatbubbles")]), _c('li', {
    staticClass: "ion-chatbox",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatbox")]), _c('li', {
    staticClass: "ion-chatbox-working",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatbox-working")]), _c('li', {
    staticClass: "ion-chatboxes",
    attrs: {
      "data-pack": "default",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-chatboxes")]), _c('li', {
    staticClass: "ion-person",
    attrs: {
      "data-pack": "default",
      "data-tags": "users, staff, head, human"
    }
  }, [_vm._v("ion-person")]), _c('li', {
    staticClass: "ion-person-add",
    attrs: {
      "data-pack": "default",
      "data-tags": "users, staff, head, human, member, new"
    }
  }, [_vm._v("ion-person-add")]), _c('li', {
    staticClass: "ion-person-stalker",
    attrs: {
      "data-pack": "default",
      "data-tags": "people, human, users, staff"
    }
  }, [_vm._v("ion-person-stalker")]), _c('li', {
    staticClass: "ion-woman",
    attrs: {
      "data-pack": "default",
      "data-tags": "female, lady, girl, dudette"
    }
  }, [_vm._v("ion-woman")]), _c('li', {
    staticClass: "ion-man",
    attrs: {
      "data-pack": "default",
      "data-tags": "male, guy, boy, dude"
    }
  }, [_vm._v("ion-man")]), _c('li', {
    staticClass: "ion-female",
    attrs: {
      "data-pack": "default",
      "data-tags": "lady, girl, dudette"
    }
  }, [_vm._v("ion-female")]), _c('li', {
    staticClass: "ion-male",
    attrs: {
      "data-pack": "default",
      "data-tags": "male, guy, boy, dude"
    }
  }, [_vm._v("ion-male")]), _c('li', {
    staticClass: "ion-transgender",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-transgender")]), _c('li', {
    staticClass: "ion-fork",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-fork")]), _c('li', {
    staticClass: "ion-knife",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-knife")]), _c('li', {
    staticClass: "ion-spoon",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-spoon")]), _c('li', {
    staticClass: "ion-soup-can-outline",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-soup-can-outline")]), _c('li', {
    staticClass: "ion-soup-can",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-soup-can")]), _c('li', {
    staticClass: "ion-beer",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-beer")]), _c('li', {
    staticClass: "ion-wineglass",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-wineglass")]), _c('li', {
    staticClass: "ion-coffee",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat, caffeine"
    }
  }, [_vm._v("ion-coffee")]), _c('li', {
    staticClass: "ion-icecream",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-icecream")]), _c('li', {
    staticClass: "ion-pizza",
    attrs: {
      "data-pack": "default",
      "data-tags": "food, drink, eat"
    }
  }, [_vm._v("ion-pizza")]), _c('li', {
    staticClass: "ion-power",
    attrs: {
      "data-pack": "default",
      "data-tags": "on, off"
    }
  }, [_vm._v("ion-power")]), _c('li', {
    staticClass: "ion-mouse",
    attrs: {
      "data-pack": "default",
      "data-tags": "computer"
    }
  }, [_vm._v("ion-mouse")]), _c('li', {
    staticClass: "ion-battery-full",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-battery-full")]), _c('li', {
    staticClass: "ion-battery-half",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-battery-half")]), _c('li', {
    staticClass: "ion-battery-low",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-battery-low")]), _c('li', {
    staticClass: "ion-battery-empty",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-battery-empty")]), _c('li', {
    staticClass: "ion-battery-charging",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-battery-charging")]), _c('li', {
    staticClass: "ion-wifi",
    attrs: {
      "data-pack": "default",
      "data-tags": "internet, connection"
    }
  }, [_vm._v("ion-wifi")]), _c('li', {
    staticClass: "ion-bluetooth",
    attrs: {
      "data-pack": "default",
      "data-tags": "connection, cloud"
    }
  }, [_vm._v("ion-bluetooth")]), _c('li', {
    staticClass: "ion-calculator",
    attrs: {
      "data-pack": "default",
      "data-tags": "math, arithmatic, numbers, addition, subtraction"
    }
  }, [_vm._v("ion-calculator")]), _c('li', {
    staticClass: "ion-camera",
    attrs: {
      "data-pack": "default",
      "data-tags": "photo"
    }
  }, [_vm._v("ion-camera")]), _c('li', {
    staticClass: "ion-eye",
    attrs: {
      "data-pack": "default",
      "data-tags": "view, see, creeper"
    }
  }, [_vm._v("ion-eye")]), _c('li', {
    staticClass: "ion-eye-disabled",
    attrs: {
      "data-pack": "default",
      "data-tags": "view, see, creeper"
    }
  }, [_vm._v("ion-eye-disabled")]), _c('li', {
    staticClass: "ion-flash",
    attrs: {
      "data-pack": "default",
      "data-tags": "lightning, weather, whether"
    }
  }, [_vm._v("ion-flash")]), _c('li', {
    staticClass: "ion-flash-off",
    attrs: {
      "data-pack": "default",
      "data-tags": ""
    }
  }, [_vm._v("ion-flash-off")]), _c('li', {
    staticClass: "ion-qr-scanner",
    attrs: {
      "data-pack": "default",
      "data-tags": "reader"
    }
  }, [_vm._v("ion-qr-scanner")]), _c('li', {
    staticClass: "ion-image",
    attrs: {
      "data-pack": "default",
      "data-tags": "photo"
    }
  }, [_vm._v("ion-image")]), _c('li', {
    staticClass: "ion-images",
    attrs: {
      "data-pack": "default",
      "data-tags": "photo"
    }
  }, [_vm._v("ion-images")]), _c('li', {
    staticClass: "ion-wand",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, levels, light, dark, settings"
    }
  }, [_vm._v("ion-wand")]), _c('li', {
    staticClass: "ion-contrast",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, levels, light, dark, settings"
    }
  }, [_vm._v("ion-contrast")]), _c('li', {
    staticClass: "ion-aperture",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, levels, light, dark, settings"
    }
  }, [_vm._v("ion-aperture")]), _c('li', {
    staticClass: "ion-crop",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, levels, light, dark, settings"
    }
  }, [_vm._v("ion-crop")]), _c('li', {
    staticClass: "ion-easel",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, art, create, color"
    }
  }, [_vm._v("ion-easel")]), _c('li', {
    staticClass: "ion-paintbrush",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, art, create, color"
    }
  }, [_vm._v("ion-paintbrush")]), _c('li', {
    staticClass: "ion-paintbucket",
    attrs: {
      "data-pack": "default",
      "data-tags": "images, art, create, color"
    }
  }, [_vm._v("ion-paintbucket")]), _c('li', {
    staticClass: "ion-monitor",
    attrs: {
      "data-pack": "default",
      "data-tags": "thunderbolt, screen"
    }
  }, [_vm._v("ion-monitor")]), _c('li', {
    staticClass: "ion-laptop",
    attrs: {
      "data-pack": "default",
      "data-tags": "macbook, apple, osx"
    }
  }, [_vm._v("ion-laptop")]), _c('li', {
    staticClass: "ion-ipad",
    attrs: {
      "data-pack": "default",
      "data-tags": "tablet, mobile, apple, retina, device"
    }
  }, [_vm._v("ion-ipad")]), _c('li', {
    staticClass: "ion-iphone",
    attrs: {
      "data-pack": "default",
      "data-tags": "smartphone, mobile, apple, retina, device"
    }
  }, [_vm._v("ion-iphone")]), _c('li', {
    staticClass: "ion-ipod",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, player, apple, retina, device"
    }
  }, [_vm._v("ion-ipod")]), _c('li', {
    staticClass: "ion-printer",
    attrs: {
      "data-pack": "default",
      "data-tags": "paper"
    }
  }, [_vm._v("ion-printer")]), _c('li', {
    staticClass: "ion-usb",
    attrs: {
      "data-pack": "default",
      "data-tags": "digital, computer"
    }
  }, [_vm._v("ion-usb")]), _c('li', {
    staticClass: "ion-outlet",
    attrs: {
      "data-pack": "default",
      "data-tags": "digital, computer, electricity"
    }
  }, [_vm._v("ion-outlet")]), _c('li', {
    staticClass: "ion-bug",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker, error"
    }
  }, [_vm._v("ion-bug")]), _c('li', {
    staticClass: "ion-code",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker"
    }
  }, [_vm._v("ion-code")]), _c('li', {
    staticClass: "ion-code-working",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker"
    }
  }, [_vm._v("ion-code-working")]), _c('li', {
    staticClass: "ion-code-download",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker"
    }
  }, [_vm._v("ion-code-download")]), _c('li', {
    staticClass: "ion-fork-repo",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker, github"
    }
  }, [_vm._v("ion-fork-repo")]), _c('li', {
    staticClass: "ion-network",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker, github"
    }
  }, [_vm._v("ion-network")]), _c('li', {
    staticClass: "ion-pull-request",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker, github"
    }
  }, [_vm._v("ion-pull-request")]), _c('li', {
    staticClass: "ion-merge",
    attrs: {
      "data-pack": "default",
      "data-tags": "develop, program, hacker, github"
    }
  }, [_vm._v("ion-merge")]), _c('li', {
    staticClass: "ion-xbox",
    attrs: {
      "data-pack": "default",
      "data-tags": "fun, games"
    }
  }, [_vm._v("ion-xbox")]), _c('li', {
    staticClass: "ion-playstation",
    attrs: {
      "data-pack": "default",
      "data-tags": "fun, games"
    }
  }, [_vm._v("ion-playstation")]), _c('li', {
    staticClass: "ion-steam",
    attrs: {
      "data-pack": "default",
      "data-tags": "fun, games"
    }
  }, [_vm._v("ion-steam")]), _c('li', {
    staticClass: "ion-closed-captioning",
    attrs: {
      "data-pack": "default",
      "data-tags": "movie, film, television"
    }
  }, [_vm._v("ion-closed-captioning")]), _c('li', {
    staticClass: "ion-videocamera",
    attrs: {
      "data-pack": "default",
      "data-tags": "movie, film, television"
    }
  }, [_vm._v("ion-videocamera")]), _c('li', {
    staticClass: "ion-film-marker",
    attrs: {
      "data-pack": "default",
      "data-tags": "film, cut, action"
    }
  }, [_vm._v("ion-film-marker")]), _c('li', {
    staticClass: "ion-disc",
    attrs: {
      "data-pack": "default",
      "data-tags": "cd, vinyl"
    }
  }, [_vm._v("ion-disc")]), _c('li', {
    staticClass: "ion-headphone",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, earbuds, beats"
    }
  }, [_vm._v("ion-headphone")]), _c('li', {
    staticClass: "ion-music-note",
    attrs: {
      "data-pack": "default",
      "data-tags": "songs"
    }
  }, [_vm._v("ion-music-note")]), _c('li', {
    staticClass: "ion-radio-waves",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, sound, speaker"
    }
  }, [_vm._v("ion-radio-waves")]), _c('li', {
    staticClass: "ion-speakerphone",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound, speaker, loud, amplify"
    }
  }, [_vm._v("ion-speakerphone")]), _c('li', {
    staticClass: "ion-mic-a",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound, talk, speaker"
    }
  }, [_vm._v("ion-mic-a")]), _c('li', {
    staticClass: "ion-mic-b",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound, talk, speaker"
    }
  }, [_vm._v("ion-mic-b")]), _c('li', {
    staticClass: "ion-mic-c",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound, talk, speaker"
    }
  }, [_vm._v("ion-mic-c")]), _c('li', {
    staticClass: "ion-volume-high",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound, noise"
    }
  }, [_vm._v("ion-volume-high")]), _c('li', {
    staticClass: "ion-volume-medium",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound"
    }
  }, [_vm._v("ion-volume-medium")]), _c('li', {
    staticClass: "ion-volume-low",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound"
    }
  }, [_vm._v("ion-volume-low")]), _c('li', {
    staticClass: "ion-volume-mute",
    attrs: {
      "data-pack": "default",
      "data-tags": "sound"
    }
  }, [_vm._v("ion-volume-mute")]), _c('li', {
    staticClass: "ion-levels",
    attrs: {
      "data-pack": "default",
      "data-tags": "options, toggles, sound, mixer"
    }
  }, [_vm._v("ion-levels")]), _c('li', {
    staticClass: "ion-play",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, watch, arrow, right"
    }
  }, [_vm._v("ion-play")]), _c('li', {
    staticClass: "ion-pause",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, break, hold, freeze"
    }
  }, [_vm._v("ion-pause")]), _c('li', {
    staticClass: "ion-stop",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, square, hold, freeze"
    }
  }, [_vm._v("ion-stop")]), _c('li', {
    staticClass: "ion-record",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, circle"
    }
  }, [_vm._v("ion-record")]), _c('li', {
    staticClass: "ion-skip-forward",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, next"
    }
  }, [_vm._v("ion-skip-forward")]), _c('li', {
    staticClass: "ion-skip-backward",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, previous"
    }
  }, [_vm._v("ion-skip-backward")]), _c('li', {
    staticClass: "ion-eject",
    attrs: {
      "data-pack": "default",
      "data-tags": "music, dvd, remove"
    }
  }, [_vm._v("ion-eject")]), _c('li', {
    staticClass: "ion-bag",
    attrs: {
      "data-pack": "default",
      "data-tags": "shopping, price, cart, money, container, $"
    }
  }, [_vm._v("ion-bag")]), _c('li', {
    staticClass: "ion-card",
    attrs: {
      "data-pack": "default",
      "data-tags": "credit, price, debit, money, shopping, cash, dollars, $"
    }
  }, [_vm._v("ion-card")]), _c('li', {
    staticClass: "ion-cash",
    attrs: {
      "data-pack": "default",
      "data-tags": "credit, price, debit, money, shopping, dollars, $"
    }
  }, [_vm._v("ion-cash")]), _c('li', {
    staticClass: "ion-pricetag",
    attrs: {
      "data-pack": "default",
      "data-tags": "credit, debit, money, shopping, cash, dollars, $"
    }
  }, [_vm._v("ion-pricetag")]), _c('li', {
    staticClass: "ion-pricetags",
    attrs: {
      "data-pack": "default",
      "data-tags": "credit, debit, money, shopping, cash, dollars, $"
    }
  }, [_vm._v("ion-pricetags")]), _c('li', {
    staticClass: "ion-thumbsup",
    attrs: {
      "data-pack": "default",
      "data-tags": "like, fun, yes"
    }
  }, [_vm._v("ion-thumbsup")]), _c('li', {
    staticClass: "ion-thumbsdown",
    attrs: {
      "data-pack": "default",
      "data-tags": "dislike, boring, no"
    }
  }, [_vm._v("ion-thumbsdown")]), _c('li', {
    staticClass: "ion-happy-outline",
    attrs: {
      "data-pack": "default",
      "data-tags": "good, like, fun, yes"
    }
  }, [_vm._v("ion-happy-outline")]), _c('li', {
    staticClass: "ion-happy",
    attrs: {
      "data-pack": "default",
      "data-tags": "good, like, fun, yes"
    }
  }, [_vm._v("ion-happy")]), _c('li', {
    staticClass: "ion-sad-outline",
    attrs: {
      "data-pack": "default",
      "data-tags": "cry, bad, no"
    }
  }, [_vm._v("ion-sad-outline")]), _c('li', {
    staticClass: "ion-sad",
    attrs: {
      "data-pack": "default",
      "data-tags": "cry, bad, no"
    }
  }, [_vm._v("ion-sad")]), _c('li', {
    staticClass: "ion-bowtie",
    attrs: {
      "data-pack": "default",
      "data-tags": "tie, shirt, dress, clothing"
    }
  }, [_vm._v("ion-bowtie")]), _c('li', {
    staticClass: "ion-tshirt-outline",
    attrs: {
      "data-pack": "default",
      "data-tags": "tie, shirt, dress, clothing"
    }
  }, [_vm._v("ion-tshirt-outline")]), _c('li', {
    staticClass: "ion-tshirt",
    attrs: {
      "data-pack": "default",
      "data-tags": "tie, shirt, dress, clothing"
    }
  }, [_vm._v("ion-tshirt")]), _c('li', {
    staticClass: "ion-trophy",
    attrs: {
      "data-pack": "default",
      "data-tags": "competition, compete, win, lose, award"
    }
  }, [_vm._v("ion-trophy")]), _c('li', {
    staticClass: "ion-podium",
    attrs: {
      "data-pack": "default",
      "data-tags": "competition, compete, win, lose, award"
    }
  }, [_vm._v("ion-podium")]), _c('li', {
    staticClass: "ion-ribbon-a",
    attrs: {
      "data-pack": "default",
      "data-tags": "competition, compete, win, lose, award, trophy"
    }
  }, [_vm._v("ion-ribbon-a")]), _c('li', {
    staticClass: "ion-ribbon-b",
    attrs: {
      "data-pack": "default",
      "data-tags": "competition, compete, win, lose, award, trophy"
    }
  }, [_vm._v("ion-ribbon-b")]), _c('li', {
    staticClass: "ion-university",
    attrs: {
      "data-pack": "default",
      "data-tags": "graduate, education, school, tassle"
    }
  }, [_vm._v("ion-university")]), _c('li', {
    staticClass: "ion-magnet",
    attrs: {
      "data-pack": "default",
      "data-tags": "sticky, attraction"
    }
  }, [_vm._v("ion-magnet")]), _c('li', {
    staticClass: "ion-beaker",
    attrs: {
      "data-pack": "default",
      "data-tags": "mixture, potion, flask"
    }
  }, [_vm._v("ion-beaker")]), _c('li', {
    staticClass: "ion-erlenmeyer-flask",
    attrs: {
      "data-pack": "default",
      "data-tags": "mixture, potion, beaker, potion"
    }
  }, [_vm._v("ion-erlenmeyer-flask")]), _c('li', {
    staticClass: "ion-egg",
    attrs: {
      "data-pack": "default",
      "data-tags": "birth, twitter, bird, baby"
    }
  }, [_vm._v("ion-egg")]), _c('li', {
    staticClass: "ion-earth",
    attrs: {
      "data-pack": "default",
      "data-tags": "nature, globe, home, planet"
    }
  }, [_vm._v("ion-earth")]), _c('li', {
    staticClass: "ion-planet",
    attrs: {
      "data-pack": "default",
      "data-tags": "nature, globe, home, planet, space"
    }
  }, [_vm._v("ion-planet")]), _c('li', {
    staticClass: "ion-lightbulb",
    attrs: {
      "data-pack": "default",
      "data-tags": "idea, new, aha!"
    }
  }, [_vm._v("ion-lightbulb")]), _c('li', {
    staticClass: "ion-cube",
    attrs: {
      "data-pack": "default",
      "data-tags": "box, square, container"
    }
  }, [_vm._v("ion-cube")]), _c('li', {
    staticClass: "ion-leaf",
    attrs: {
      "data-pack": "default",
      "data-tags": "green, recycle, plant, nature"
    }
  }, [_vm._v("ion-leaf")]), _c('li', {
    staticClass: "ion-waterdrop",
    attrs: {
      "data-pack": "default",
      "data-tags": "nature, clean, recycle, fresh, wet, rain"
    }
  }, [_vm._v("ion-waterdrop")]), _c('li', {
    staticClass: "ion-flame",
    attrs: {
      "data-pack": "default",
      "data-tags": "fire, hot, heat"
    }
  }, [_vm._v("ion-flame")]), _c('li', {
    staticClass: "ion-fireball",
    attrs: {
      "data-pack": "default",
      "data-tags": "hot, heat"
    }
  }, [_vm._v("ion-fireball")]), _c('li', {
    staticClass: "ion-bonfire",
    attrs: {
      "data-pack": "default",
      "data-tags": "hot, heat"
    }
  }, [_vm._v("ion-bonfire")]), _c('li', {
    staticClass: "ion-umbrella",
    attrs: {
      "data-pack": "default",
      "data-tags": "wet, rain, dry, shelter"
    }
  }, [_vm._v("ion-umbrella")]), _c('li', {
    staticClass: "ion-nuclear",
    attrs: {
      "data-pack": "default",
      "data-tags": "danger, warning, hazard"
    }
  }, [_vm._v("ion-nuclear")]), _c('li', {
    staticClass: "ion-no-smoking",
    attrs: {
      "data-pack": "default",
      "data-tags": "danger, warning, cigarette, cancer"
    }
  }, [_vm._v("ion-no-smoking")]), _c('li', {
    staticClass: "ion-thermometer",
    attrs: {
      "data-pack": "default",
      "data-tags": "hot, cold, heat, temperature, mercury"
    }
  }, [_vm._v("ion-thermometer")]), _c('li', {
    staticClass: "ion-speedometer",
    attrs: {
      "data-pack": "default",
      "data-tags": "travel, accelerate"
    }
  }, [_vm._v("ion-speedometer")]), _c('li', {
    staticClass: "ion-model-s",
    attrs: {
      "data-pack": "default",
      "data-tags": "navigation, car, drive, transportation, tesla, sexy"
    }
  }, [_vm._v("ion-model-s")]), _c('li', {
    staticClass: "ion-plane",
    attrs: {
      "data-pack": "default",
      "data-tags": "fly, jet"
    }
  }, [_vm._v("ion-plane")]), _c('li', {
    staticClass: "ion-jet",
    attrs: {
      "data-pack": "default",
      "data-tags": "fly, plane"
    }
  }, [_vm._v("ion-jet")]), _c('li', {
    staticClass: "ion-load-a",
    attrs: {
      "data-pack": "default",
      "data-tags": "spinner, waiting, refresh"
    }
  }, [_vm._v("ion-load-a")]), _c('li', {
    staticClass: "ion-load-b",
    attrs: {
      "data-pack": "default",
      "data-tags": "spinner, waiting, refresh"
    }
  }, [_vm._v("ion-load-b")]), _c('li', {
    staticClass: "ion-load-c",
    attrs: {
      "data-pack": "default",
      "data-tags": "spinner, waiting, refresh"
    }
  }, [_vm._v("ion-load-c")]), _c('li', {
    staticClass: "ion-load-d",
    attrs: {
      "data-pack": "default",
      "data-tags": "spinner, waiting, refresh"
    }
  }, [_vm._v("ion-load-d")]), _c('p'), _c('li', {
    staticClass: "ion-ios-ionic-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "badass, framework, sexy"
    }
  }, [_vm._v("ion-ios-ionic-outline")]), _c('li', {
    staticClass: "ion-ios-arrow-back",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron, left"
    }
  }, [_vm._v("ion-ios-arrow-back")]), _c('li', {
    staticClass: "ion-ios-arrow-forward",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron, right"
    }
  }, [_vm._v("ion-ios-arrow-forward")]), _c('li', {
    staticClass: "ion-ios-arrow-up",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-up")]), _c('li', {
    staticClass: "ion-ios-arrow-right",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-right")]), _c('li', {
    staticClass: "ion-ios-arrow-down",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-down")]), _c('li', {
    staticClass: "ion-ios-arrow-left",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-left")]), _c('li', {
    staticClass: "ion-ios-arrow-thin-up",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-thin-up")]), _c('li', {
    staticClass: "ion-ios-arrow-thin-right",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-thin-right")]), _c('li', {
    staticClass: "ion-ios-arrow-thin-down",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-thin-down")]), _c('li', {
    staticClass: "ion-ios-arrow-thin-left",
    attrs: {
      "data-pack": "ios",
      "data-tags": "chevron"
    }
  }, [_vm._v("ion-ios-arrow-thin-left")]), _c('li', {
    staticClass: "ion-ios-circle-filled",
    attrs: {
      "data-pack": "ios",
      "data-tags": "checkmark, radio, dot, on, selected, button"
    }
  }, [_vm._v("ion-ios-circle-filled")]), _c('li', {
    staticClass: "ion-ios-circle-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "checkmark, radio, dot, off, button"
    }
  }, [_vm._v("ion-ios-circle-outline")]), _c('li', {
    staticClass: "ion-ios-checkmark-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "success, confirmed, on, finished, complete"
    }
  }, [_vm._v("ion-ios-checkmark-empty")]), _c('li', {
    staticClass: "ion-ios-checkmark-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "success, confirmed, on, finished, complete"
    }
  }, [_vm._v("ion-ios-checkmark-outline")]), _c('li', {
    staticClass: "ion-ios-checkmark",
    attrs: {
      "data-pack": "ios",
      "data-tags": "success, confirmed, on, finished, complete"
    }
  }, [_vm._v("ion-ios-checkmark")]), _c('li', {
    staticClass: "ion-ios-plus-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-ios-plus-empty")]), _c('li', {
    staticClass: "ion-ios-plus-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-ios-plus-outline")]), _c('li', {
    staticClass: "ion-ios-plus",
    attrs: {
      "data-pack": "ios",
      "data-tags": "add, include, new, invite, +"
    }
  }, [_vm._v("ion-ios-plus")]), _c('li', {
    staticClass: "ion-ios-close-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "delete, remove, trash, end, stop, x"
    }
  }, [_vm._v("ion-ios-close-empty")]), _c('li', {
    staticClass: "ion-ios-close-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "delete, remove, trash, end, stop, x"
    }
  }, [_vm._v("ion-ios-close-outline")]), _c('li', {
    staticClass: "ion-ios-close",
    attrs: {
      "data-pack": "ios",
      "data-tags": "delete, remove, trash, end, stop, x"
    }
  }, [_vm._v("ion-ios-close")]), _c('li', {
    staticClass: "ion-ios-minus-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-ios-minus-empty")]), _c('li', {
    staticClass: "ion-ios-minus-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-ios-minus-outline")]), _c('li', {
    staticClass: "ion-ios-minus",
    attrs: {
      "data-pack": "ios",
      "data-tags": "hide, remove, minimize, -"
    }
  }, [_vm._v("ion-ios-minus")]), _c('li', {
    staticClass: "ion-ios-information-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "help, question"
    }
  }, [_vm._v("ion-ios-information-empty")]), _c('li', {
    staticClass: "ion-ios-information-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "help, question"
    }
  }, [_vm._v("ion-ios-information-outline")]), _c('li', {
    staticClass: "ion-ios-information",
    attrs: {
      "data-pack": "ios",
      "data-tags": "help, question"
    }
  }, [_vm._v("ion-ios-information")]), _c('li', {
    staticClass: "ion-ios-help-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "question, information, ?"
    }
  }, [_vm._v("ion-ios-help-empty")]), _c('li', {
    staticClass: "ion-ios-help-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "question, information, ?"
    }
  }, [_vm._v("ion-ios-help-outline")]), _c('li', {
    staticClass: "ion-ios-help",
    attrs: {
      "data-pack": "ios",
      "data-tags": "question, information, ?"
    }
  }, [_vm._v("ion-ios-help")]), _c('li', {
    staticClass: "ion-ios-search",
    attrs: {
      "data-pack": "ios",
      "data-tags": "find, seek, look, magnifying glass"
    }
  }, [_vm._v("ion-ios-search")]), _c('li', {
    staticClass: "ion-ios-search-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "find, seek, look, magnifying glass"
    }
  }, [_vm._v("ion-ios-search-strong")]), _c('li', {
    staticClass: "ion-ios-star",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite, rate"
    }
  }, [_vm._v("ion-ios-star")]), _c('li', {
    staticClass: "ion-ios-star-half",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite, rate"
    }
  }, [_vm._v("ion-ios-star-half")]), _c('li', {
    staticClass: "ion-ios-star-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite, rate"
    }
  }, [_vm._v("ion-ios-star-outline")]), _c('li', {
    staticClass: "ion-ios-heart",
    attrs: {
      "data-pack": "ios",
      "data-tags": "love"
    }
  }, [_vm._v("ion-ios-heart")]), _c('li', {
    staticClass: "ion-ios-heart-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "love"
    }
  }, [_vm._v("ion-ios-heart-outline")]), _c('li', {
    staticClass: "ion-ios-more",
    attrs: {
      "data-pack": "ios",
      "data-tags": "menu"
    }
  }, [_vm._v("ion-ios-more")]), _c('li', {
    staticClass: "ion-ios-more-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "menu"
    }
  }, [_vm._v("ion-ios-more-outline")]), _c('li', {
    staticClass: "ion-ios-home",
    attrs: {
      "data-pack": "ios",
      "data-tags": "house"
    }
  }, [_vm._v("ion-ios-home")]), _c('li', {
    staticClass: "ion-ios-home-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "house"
    }
  }, [_vm._v("ion-ios-home-outline")]), _c('li', {
    staticClass: "ion-ios-cloud",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage, weather, whether"
    }
  }, [_vm._v("ion-ios-cloud")]), _c('li', {
    staticClass: "ion-ios-cloud-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage, weather, whether"
    }
  }, [_vm._v("ion-ios-cloud-outline")]), _c('li', {
    staticClass: "ion-ios-cloud-upload",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage"
    }
  }, [_vm._v("ion-ios-cloud-upload")]), _c('li', {
    staticClass: "ion-ios-cloud-upload-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage"
    }
  }, [_vm._v("ion-ios-cloud-upload-outline")]), _c('li', {
    staticClass: "ion-ios-cloud-download",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage"
    }
  }, [_vm._v("ion-ios-cloud-download")]), _c('li', {
    staticClass: "ion-ios-cloud-download-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "storage"
    }
  }, [_vm._v("ion-ios-cloud-download-outline")]), _c('li', {
    staticClass: "ion-ios-upload",
    attrs: {
      "data-pack": "ios",
      "data-tags": "share, import"
    }
  }, [_vm._v("ion-ios-upload")]), _c('li', {
    staticClass: "ion-ios-upload-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "share, import"
    }
  }, [_vm._v("ion-ios-upload-outline")]), _c('li', {
    staticClass: "ion-ios-download",
    attrs: {
      "data-pack": "ios",
      "data-tags": "save, export"
    }
  }, [_vm._v("ion-ios-download")]), _c('li', {
    staticClass: "ion-ios-download-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "save, export"
    }
  }, [_vm._v("ion-ios-download-outline")]), _c('li', {
    staticClass: "ion-ios-refresh",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reload, renew, reset"
    }
  }, [_vm._v("ion-ios-refresh")]), _c('li', {
    staticClass: "ion-ios-refresh-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reload, renew, reset"
    }
  }, [_vm._v("ion-ios-refresh-outline")]), _c('li', {
    staticClass: "ion-ios-refresh-empty",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reload, renew"
    }
  }, [_vm._v("ion-ios-refresh-empty")]), _c('li', {
    staticClass: "ion-ios-reload",
    attrs: {
      "data-pack": "ios",
      "data-tags": "renew, reset"
    }
  }, [_vm._v("ion-ios-reload")]), _c('li', {
    staticClass: "ion-ios-loop-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reload, renew, reset"
    }
  }, [_vm._v("ion-ios-loop-strong")]), _c('li', {
    staticClass: "ion-ios-loop",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reload, renew, reset"
    }
  }, [_vm._v("ion-ios-loop")]), _c('li', {
    staticClass: "ion-ios-bookmarks",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite"
    }
  }, [_vm._v("ion-ios-bookmarks")]), _c('li', {
    staticClass: "ion-ios-bookmarks-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite"
    }
  }, [_vm._v("ion-ios-bookmarks-outline")]), _c('li', {
    staticClass: "ion-ios-book",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite, read, literature"
    }
  }, [_vm._v("ion-ios-book")]), _c('li', {
    staticClass: "ion-ios-book-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "favorite, read, literature"
    }
  }, [_vm._v("ion-ios-book-outline")]), _c('li', {
    staticClass: "ion-ios-flag",
    attrs: {
      "data-pack": "ios",
      "data-tags": "marker, favorite"
    }
  }, [_vm._v("ion-ios-flag")]), _c('li', {
    staticClass: "ion-ios-flag-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "marker, favorite"
    }
  }, [_vm._v("ion-ios-flag-outline")]), _c('li', {
    staticClass: "ion-ios-glasses",
    attrs: {
      "data-pack": "ios",
      "data-tags": "steve, reading, look, see"
    }
  }, [_vm._v("ion-ios-glasses")]), _c('li', {
    staticClass: "ion-ios-glasses-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "steve, reading, look, see"
    }
  }, [_vm._v("ion-ios-glasses-outline")]), _c('li', {
    staticClass: "ion-ios-browsers",
    attrs: {
      "data-pack": "ios",
      "data-tags": "square"
    }
  }, [_vm._v("ion-ios-browsers")]), _c('li', {
    staticClass: "ion-ios-browsers-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "square"
    }
  }, [_vm._v("ion-ios-browsers-outline")]), _c('li', {
    staticClass: "ion-ios-at",
    attrs: {
      "data-pack": "ios",
      "data-tags": "@"
    }
  }, [_vm._v("ion-ios-at")]), _c('li', {
    staticClass: "ion-ios-at-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "@"
    }
  }, [_vm._v("ion-ios-at-outline")]), _c('li', {
    staticClass: "ion-ios-pricetag",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-pricetag")]), _c('li', {
    staticClass: "ion-ios-pricetag-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-pricetag-outline")]), _c('li', {
    staticClass: "ion-ios-pricetags",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-pricetags")]), _c('li', {
    staticClass: "ion-ios-pricetags-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-pricetags-outline")]), _c('li', {
    staticClass: "ion-ios-cart",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-cart")]), _c('li', {
    staticClass: "ion-ios-cart-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "shopping, money, items, commerce, $"
    }
  }, [_vm._v("ion-ios-cart-outline")]), _c('li', {
    staticClass: "ion-ios-chatboxes",
    attrs: {
      "data-pack": "ios",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-ios-chatboxes")]), _c('li', {
    staticClass: "ion-ios-chatboxes-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-ios-chatboxes-outline")]), _c('li', {
    staticClass: "ion-ios-chatbubble",
    attrs: {
      "data-pack": "ios",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-ios-chatbubble")]), _c('li', {
    staticClass: "ion-ios-chatbubble-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "talk"
    }
  }, [_vm._v("ion-ios-chatbubble-outline")]), _c('li', {
    staticClass: "ion-ios-cog",
    attrs: {
      "data-pack": "ios",
      "data-tags": "settings, gear, options"
    }
  }, [_vm._v("ion-ios-cog")]), _c('li', {
    staticClass: "ion-ios-cog-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "settings, gear, options"
    }
  }, [_vm._v("ion-ios-cog-outline")]), _c('li', {
    staticClass: "ion-ios-gear",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-gear")]), _c('li', {
    staticClass: "ion-ios-gear-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-gear-outline")]), _c('li', {
    staticClass: "ion-ios-settings",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-settings")]), _c('li', {
    staticClass: "ion-ios-settings-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-settings-strong")]), _c('li', {
    staticClass: "ion-ios-toggle",
    attrs: {
      "data-pack": "ios",
      "data-tags": "settings, options, switch"
    }
  }, [_vm._v("ion-ios-toggle")]), _c('li', {
    staticClass: "ion-ios-toggle-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "settings, options, switch"
    }
  }, [_vm._v("ion-ios-toggle-outline")]), _c('li', {
    staticClass: "ion-ios-analytics",
    attrs: {
      "data-pack": "ios",
      "data-tags": "metrics, track, data"
    }
  }, [_vm._v("ion-ios-analytics")]), _c('li', {
    staticClass: "ion-ios-analytics-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "metrics, track, data"
    }
  }, [_vm._v("ion-ios-analytics-outline")]), _c('li', {
    staticClass: "ion-ios-pie",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-pie")]), _c('li', {
    staticClass: "ion-ios-pie-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cog, settings, options"
    }
  }, [_vm._v("ion-ios-pie-outline")]), _c('li', {
    staticClass: "ion-ios-pulse",
    attrs: {
      "data-pack": "ios",
      "data-tags": "live, hot, rate"
    }
  }, [_vm._v("ion-ios-pulse")]), _c('li', {
    staticClass: "ion-ios-pulse-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "live, hot, rate"
    }
  }, [_vm._v("ion-ios-pulse-strong")]), _c('li', {
    staticClass: "ion-ios-filing",
    attrs: {
      "data-pack": "ios",
      "data-tags": "archive"
    }
  }, [_vm._v("ion-ios-filing")]), _c('li', {
    staticClass: "ion-ios-filing-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "archive"
    }
  }, [_vm._v("ion-ios-filing-outline")]), _c('li', {
    staticClass: "ion-ios-box",
    attrs: {
      "data-pack": "ios",
      "data-tags": "archive"
    }
  }, [_vm._v("ion-ios-box")]), _c('li', {
    staticClass: "ion-ios-box-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "archive"
    }
  }, [_vm._v("ion-ios-box-outline")]), _c('li', {
    staticClass: "ion-ios-compose",
    attrs: {
      "data-pack": "ios",
      "data-tags": "write, type, create"
    }
  }, [_vm._v("ion-ios-compose")]), _c('li', {
    staticClass: "ion-ios-compose-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "write, type, create"
    }
  }, [_vm._v("ion-ios-compose-outline")]), _c('li', {
    staticClass: "ion-ios-trash",
    attrs: {
      "data-pack": "ios",
      "data-tags": "delete, remove, dispose, waste, basket, dump, kill"
    }
  }, [_vm._v("ion-ios-trash")]), _c('li', {
    staticClass: "ion-ios-trash-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "delete, remove, dispose, waste, basket, dump, kill"
    }
  }, [_vm._v("ion-ios-trash-outline")]), _c('li', {
    staticClass: "ion-ios-copy",
    attrs: {
      "data-pack": "ios",
      "data-tags": "duplicate, paper"
    }
  }, [_vm._v("ion-ios-copy")]), _c('li', {
    staticClass: "ion-ios-copy-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "duplicate, paper"
    }
  }, [_vm._v("ion-ios-copy-outline")]), _c('li', {
    staticClass: "ion-ios-email",
    attrs: {
      "data-pack": "ios",
      "data-tags": "snail, mail"
    }
  }, [_vm._v("ion-ios-email")]), _c('li', {
    staticClass: "ion-ios-email-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "snail, mail"
    }
  }, [_vm._v("ion-ios-email-outline")]), _c('li', {
    staticClass: "ion-ios-undo",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reply"
    }
  }, [_vm._v("ion-ios-undo")]), _c('li', {
    staticClass: "ion-ios-undo-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reply"
    }
  }, [_vm._v("ion-ios-undo-outline")]), _c('li', {
    staticClass: "ion-ios-redo",
    attrs: {
      "data-pack": "ios",
      "data-tags": "forward"
    }
  }, [_vm._v("ion-ios-redo")]), _c('li', {
    staticClass: "ion-ios-redo-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "forward"
    }
  }, [_vm._v("ion-ios-redo-outline")]), _c('li', {
    staticClass: "ion-ios-paperplane",
    attrs: {
      "data-pack": "ios",
      "data-tags": "send"
    }
  }, [_vm._v("ion-ios-paperplane")]), _c('li', {
    staticClass: "ion-ios-paperplane-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "send"
    }
  }, [_vm._v("ion-ios-paperplane-outline")]), _c('li', {
    staticClass: "ion-ios-folder",
    attrs: {
      "data-pack": "ios",
      "data-tags": "file"
    }
  }, [_vm._v("ion-ios-folder")]), _c('li', {
    staticClass: "ion-ios-folder-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "file"
    }
  }, [_vm._v("ion-ios-folder-outline")]), _c('li', {
    staticClass: "ion-ios-paper",
    attrs: {
      "data-pack": "ios",
      "data-tags": "feed, paper"
    }
  }, [_vm._v("ion-ios-paper")]), _c('li', {
    staticClass: "ion-ios-paper-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "feed, paper"
    }
  }, [_vm._v("ion-ios-paper-outline")]), _c('li', {
    staticClass: "ion-ios-list",
    attrs: {
      "data-pack": "ios",
      "data-tags": "todo, feed, paper"
    }
  }, [_vm._v("ion-ios-list")]), _c('li', {
    staticClass: "ion-ios-list-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "todo, feed, paper"
    }
  }, [_vm._v("ion-ios-list-outline")]), _c('li', {
    staticClass: "ion-ios-world",
    attrs: {
      "data-pack": "ios",
      "data-tags": "globe, earth"
    }
  }, [_vm._v("ion-ios-world")]), _c('li', {
    staticClass: "ion-ios-world-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "globe, earth"
    }
  }, [_vm._v("ion-ios-world-outline")]), _c('li', {
    staticClass: "ion-ios-alarm",
    attrs: {
      "data-pack": "ios",
      "data-tags": "wake, ring"
    }
  }, [_vm._v("ion-ios-alarm")]), _c('li', {
    staticClass: "ion-ios-alarm-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "wake, ring"
    }
  }, [_vm._v("ion-ios-alarm-outline")]), _c('li', {
    staticClass: "ion-ios-speedometer",
    attrs: {
      "data-pack": "ios",
      "data-tags": "speed, drive, level"
    }
  }, [_vm._v("ion-ios-speedometer")]), _c('li', {
    staticClass: "ion-ios-speedometer-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "speed, drive, level"
    }
  }, [_vm._v("ion-ios-speedometer-outline")]), _c('li', {
    staticClass: "ion-ios-stopwatch",
    attrs: {
      "data-pack": "ios",
      "data-tags": "time, speed"
    }
  }, [_vm._v("ion-ios-stopwatch")]), _c('li', {
    staticClass: "ion-ios-stopwatch-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "time, speed"
    }
  }, [_vm._v("ion-ios-stopwatch-outline")]), _c('li', {
    staticClass: "ion-ios-timer",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cooking, alarm, buzz"
    }
  }, [_vm._v("ion-ios-timer")]), _c('li', {
    staticClass: "ion-ios-timer-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cooking, alarm, buzz"
    }
  }, [_vm._v("ion-ios-timer-outline")]), _c('li', {
    staticClass: "ion-ios-clock",
    attrs: {
      "data-pack": "ios",
      "data-tags": "time, date, hours, minutes, seconds, watch"
    }
  }, [_vm._v("ion-ios-clock")]), _c('li', {
    staticClass: "ion-ios-clock-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "time, date, hours, minutes, seconds, watch"
    }
  }, [_vm._v("ion-ios-clock-outline")]), _c('li', {
    staticClass: "ion-ios-time",
    attrs: {
      "data-pack": "ios",
      "data-tags": "clock, watch, hour, minute, second"
    }
  }, [_vm._v("ion-ios-time")]), _c('li', {
    staticClass: "ion-ios-time-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "clock, watch, hour, minute, second"
    }
  }, [_vm._v("ion-ios-time-outline")]), _c('li', {
    staticClass: "ion-ios-calendar",
    attrs: {
      "data-pack": "ios",
      "data-tags": "date, time, month, year"
    }
  }, [_vm._v("ion-ios-calendar")]), _c('li', {
    staticClass: "ion-ios-calendar-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "date, time, month, year"
    }
  }, [_vm._v("ion-ios-calendar-outline")]), _c('li', {
    staticClass: "ion-ios-photos",
    attrs: {
      "data-pack": "ios",
      "data-tags": "images, stills, square"
    }
  }, [_vm._v("ion-ios-photos")]), _c('li', {
    staticClass: "ion-ios-photos-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "images, stills, square"
    }
  }, [_vm._v("ion-ios-photos-outline")]), _c('li', {
    staticClass: "ion-ios-albums",
    attrs: {
      "data-pack": "ios",
      "data-tags": "square, boxes, slides"
    }
  }, [_vm._v("ion-ios-albums")]), _c('li', {
    staticClass: "ion-ios-albums-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "square, boxes, slides"
    }
  }, [_vm._v("ion-ios-albums-outline")]), _c('li', {
    staticClass: "ion-ios-camera",
    attrs: {
      "data-pack": "ios",
      "data-tags": "picture"
    }
  }, [_vm._v("ion-ios-camera")]), _c('li', {
    staticClass: "ion-ios-camera-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "picture"
    }
  }, [_vm._v("ion-ios-camera-outline")]), _c('li', {
    staticClass: "ion-ios-reverse-camera",
    attrs: {
      "data-pack": "ios",
      "data-tags": "picture"
    }
  }, [_vm._v("ion-ios-reverse-camera")]), _c('li', {
    staticClass: "ion-ios-reverse-camera-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "picture"
    }
  }, [_vm._v("ion-ios-reverse-camera-outline")]), _c('li', {
    staticClass: "ion-ios-eye",
    attrs: {
      "data-pack": "ios",
      "data-tags": "view, see, exposed, look"
    }
  }, [_vm._v("ion-ios-eye")]), _c('li', {
    staticClass: "ion-ios-eye-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "view, see, exposed, look"
    }
  }, [_vm._v("ion-ios-eye-outline")]), _c('li', {
    staticClass: "ion-ios-bolt",
    attrs: {
      "data-pack": "ios",
      "data-tags": "flash, lightning"
    }
  }, [_vm._v("ion-ios-bolt")]), _c('li', {
    staticClass: "ion-ios-bolt-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "flash, lightning"
    }
  }, [_vm._v("ion-ios-bolt-outline")]), _c('li', {
    staticClass: "ion-ios-color-wand",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture, edit, magic"
    }
  }, [_vm._v("ion-ios-color-wand")]), _c('li', {
    staticClass: "ion-ios-color-wand-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture, edit, magic"
    }
  }, [_vm._v("ion-ios-color-wand-outline")]), _c('li', {
    staticClass: "ion-ios-color-filter",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture"
    }
  }, [_vm._v("ion-ios-color-filter")]), _c('li', {
    staticClass: "ion-ios-color-filter-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture"
    }
  }, [_vm._v("ion-ios-color-filter-outline")]), _c('li', {
    staticClass: "ion-ios-grid-view",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture"
    }
  }, [_vm._v("ion-ios-grid-view")]), _c('li', {
    staticClass: "ion-ios-grid-view-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture"
    }
  }, [_vm._v("ion-ios-grid-view-outline")]), _c('li', {
    staticClass: "ion-ios-crop-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture, edit"
    }
  }, [_vm._v("ion-ios-crop-strong")]), _c('li', {
    staticClass: "ion-ios-crop",
    attrs: {
      "data-pack": "ios",
      "data-tags": "camera, picture, edit"
    }
  }, [_vm._v("ion-ios-crop")]), _c('li', {
    staticClass: "ion-ios-barcode",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reader, camera"
    }
  }, [_vm._v("ion-ios-barcode")]), _c('li', {
    staticClass: "ion-ios-barcode-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reader, camera"
    }
  }, [_vm._v("ion-ios-barcode-outline")]), _c('li', {
    staticClass: "ion-ios-briefcase",
    attrs: {
      "data-pack": "ios",
      "data-tags": "organize, folder"
    }
  }, [_vm._v("ion-ios-briefcase")]), _c('li', {
    staticClass: "ion-ios-briefcase-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "organize, folder"
    }
  }, [_vm._v("ion-ios-briefcase-outline")]), _c('li', {
    staticClass: "ion-ios-medkit",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, case, first aid, sick, disease"
    }
  }, [_vm._v("ion-ios-medkit")]), _c('li', {
    staticClass: "ion-ios-medkit-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, case, first aid, sick, disease"
    }
  }, [_vm._v("ion-ios-medkit-outline")]), _c('li', {
    staticClass: "ion-ios-medical",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, case, first aid, sick, disease"
    }
  }, [_vm._v("ion-ios-medical")]), _c('li', {
    staticClass: "ion-ios-medical-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, case, first aid, sick, disease"
    }
  }, [_vm._v("ion-ios-medical-outline")]), _c('li', {
    staticClass: "ion-ios-infinite",
    attrs: {
      "data-pack": "ios",
      "data-tags": "forever, loop"
    }
  }, [_vm._v("ion-ios-infinite")]), _c('li', {
    staticClass: "ion-ios-infinite-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "forever, loop"
    }
  }, [_vm._v("ion-ios-infinite-outline")]), _c('li', {
    staticClass: "ion-ios-calculator",
    attrs: {
      "data-pack": "ios",
      "data-tags": "math, arithmatic"
    }
  }, [_vm._v("ion-ios-calculator")]), _c('li', {
    staticClass: "ion-ios-calculator-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "math, arithmatic"
    }
  }, [_vm._v("ion-ios-calculator-outline")]), _c('li', {
    staticClass: "ion-ios-keypad",
    attrs: {
      "data-pack": "ios",
      "data-tags": "type, grid, circle"
    }
  }, [_vm._v("ion-ios-keypad")]), _c('li', {
    staticClass: "ion-ios-keypad-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "type, grid, circle"
    }
  }, [_vm._v("ion-ios-keypad-outline")]), _c('li', {
    staticClass: "ion-ios-telephone",
    attrs: {
      "data-pack": "ios",
      "data-tags": "oldschool, call"
    }
  }, [_vm._v("ion-ios-telephone")]), _c('li', {
    staticClass: "ion-ios-telephone-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "oldschool, call"
    }
  }, [_vm._v("ion-ios-telephone-outline")]), _c('li', {
    staticClass: "ion-ios-drag",
    attrs: {
      "data-pack": "ios",
      "data-tags": "reorder, move, drag"
    }
  }, [_vm._v("ion-ios-drag")]), _c('li', {
    staticClass: "ion-ios-location",
    attrs: {
      "data-pack": "ios",
      "data-tags": "navigation, map, gps, pin"
    }
  }, [_vm._v("ion-ios-location")]), _c('li', {
    staticClass: "ion-ios-location-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "navigation, map, gps, pin"
    }
  }, [_vm._v("ion-ios-location-outline")]), _c('li', {
    staticClass: "ion-ios-navigate",
    attrs: {
      "data-pack": "ios",
      "data-tags": "location, map, gps, pin"
    }
  }, [_vm._v("ion-ios-navigate")]), _c('li', {
    staticClass: "ion-ios-navigate-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "location, map, gps, pin"
    }
  }, [_vm._v("ion-ios-navigate-outline")]), _c('li', {
    staticClass: "ion-ios-locked",
    attrs: {
      "data-pack": "ios",
      "data-tags": "security, padlock, safe"
    }
  }, [_vm._v("ion-ios-locked")]), _c('li', {
    staticClass: "ion-ios-locked-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "security, padlock, safe"
    }
  }, [_vm._v("ion-ios-locked-outline")]), _c('li', {
    staticClass: "ion-ios-unlocked",
    attrs: {
      "data-pack": "ios",
      "data-tags": "security, padlock, safe"
    }
  }, [_vm._v("ion-ios-unlocked")]), _c('li', {
    staticClass: "ion-ios-unlocked-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "security, padlock, safe"
    }
  }, [_vm._v("ion-ios-unlocked-outline")]), _c('li', {
    staticClass: "ion-ios-monitor",
    attrs: {
      "data-pack": "ios",
      "data-tags": "thunderbolt, display, screen"
    }
  }, [_vm._v("ion-ios-monitor")]), _c('li', {
    staticClass: "ion-ios-monitor-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "thunderbolt, display, screen"
    }
  }, [_vm._v("ion-ios-monitor-outline")]), _c('li', {
    staticClass: "ion-ios-printer",
    attrs: {
      "data-pack": "ios",
      "data-tags": "paper"
    }
  }, [_vm._v("ion-ios-printer")]), _c('li', {
    staticClass: "ion-ios-printer-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "paper"
    }
  }, [_vm._v("ion-ios-printer-outline")]), _c('li', {
    staticClass: "ion-ios-game-controller-a",
    attrs: {
      "data-pack": "ios",
      "data-tags": "gaming, nintendo, play"
    }
  }, [_vm._v("ion-ios-game-controller-a")]), _c('li', {
    staticClass: "ion-ios-game-controller-a-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "gaming, nintendo, play"
    }
  }, [_vm._v("ion-ios-game-controller-a-outline")]), _c('li', {
    staticClass: "ion-ios-game-controller-b",
    attrs: {
      "data-pack": "ios",
      "data-tags": "gaming, nintendo, play"
    }
  }, [_vm._v("ion-ios-game-controller-b")]), _c('li', {
    staticClass: "ion-ios-game-controller-b-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "gaming, nintendo, play"
    }
  }, [_vm._v("ion-ios-game-controller-b-outline")]), _c('li', {
    staticClass: "ion-ios-americanfootball",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nfl, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-americanfootball")]), _c('li', {
    staticClass: "ion-ios-americanfootball-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nfl, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-americanfootball-outline")]), _c('li', {
    staticClass: "ion-ios-baseball",
    attrs: {
      "data-pack": "ios",
      "data-tags": "mlb, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-baseball")]), _c('li', {
    staticClass: "ion-ios-baseball-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "mlb, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-baseball-outline")]), _c('li', {
    staticClass: "ion-ios-basketball",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nba, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-basketball")]), _c('li', {
    staticClass: "ion-ios-basketball-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nba, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-basketball-outline")]), _c('li', {
    staticClass: "ion-ios-tennisball",
    attrs: {
      "data-pack": "ios",
      "data-tags": "games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-tennisball")]), _c('li', {
    staticClass: "ion-ios-tennisball-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-tennisball-outline")]), _c('li', {
    staticClass: "ion-ios-football",
    attrs: {
      "data-pack": "ios",
      "data-tags": "mls, soccer, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-football")]), _c('li', {
    staticClass: "ion-ios-football-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "mls, soccer, games, sports, fun, play"
    }
  }, [_vm._v("ion-ios-football-outline")]), _c('li', {
    staticClass: "ion-ios-body",
    attrs: {
      "data-pack": "ios",
      "data-tags": "person, users, staff, head, human"
    }
  }, [_vm._v("ion-ios-body")]), _c('li', {
    staticClass: "ion-ios-body-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "person, users, staff, head, human"
    }
  }, [_vm._v("ion-ios-body-outline")]), _c('li', {
    staticClass: "ion-ios-person",
    attrs: {
      "data-pack": "ios",
      "data-tags": "users, staff, head, human"
    }
  }, [_vm._v("ion-ios-person")]), _c('li', {
    staticClass: "ion-ios-person-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "users, staff, head, human"
    }
  }, [_vm._v("ion-ios-person-outline")]), _c('li', {
    staticClass: "ion-ios-personadd",
    attrs: {
      "data-pack": "ios",
      "data-tags": "users, staff, head, human, new, invite"
    }
  }, [_vm._v("ion-ios-personadd")]), _c('li', {
    staticClass: "ion-ios-personadd-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "users, staff, head, human, new, invite"
    }
  }, [_vm._v("ion-ios-personadd-outline")]), _c('li', {
    staticClass: "ion-ios-people",
    attrs: {
      "data-pack": "ios",
      "data-tags": "stalker, person, users, head, human"
    }
  }, [_vm._v("ion-ios-people")]), _c('li', {
    staticClass: "ion-ios-people-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "stalker, person, users, head, human"
    }
  }, [_vm._v("ion-ios-people-outline")]), _c('li', {
    staticClass: "ion-ios-musical-notes",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, listening, play"
    }
  }, [_vm._v("ion-ios-musical-notes")]), _c('li', {
    staticClass: "ion-ios-musical-note",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, listening, play"
    }
  }, [_vm._v("ion-ios-musical-note")]), _c('li', {
    staticClass: "ion-ios-bell",
    attrs: {
      "data-pack": "ios",
      "data-tags": "right, noise, alarm, sound, music"
    }
  }, [_vm._v("ion-ios-bell")]), _c('li', {
    staticClass: "ion-ios-bell-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "right, noise, alarm, sound, music"
    }
  }, [_vm._v("ion-ios-bell-outline")]), _c('li', {
    staticClass: "ion-ios-mic",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, speaker, talk"
    }
  }, [_vm._v("ion-ios-mic")]), _c('li', {
    staticClass: "ion-ios-mic-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, speaker, talk"
    }
  }, [_vm._v("ion-ios-mic-outline")]), _c('li', {
    staticClass: "ion-ios-mic-off",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, speaker, talk"
    }
  }, [_vm._v("ion-ios-mic-off")]), _c('li', {
    staticClass: "ion-ios-volume-high",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, listen, music"
    }
  }, [_vm._v("ion-ios-volume-high")]), _c('li', {
    staticClass: "ion-ios-volume-low",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sound, noise, listen, music"
    }
  }, [_vm._v("ion-ios-volume-low")]), _c('li', {
    staticClass: "ion-ios-play",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, watch, arrow, right"
    }
  }, [_vm._v("ion-ios-play")]), _c('li', {
    staticClass: "ion-ios-play-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, watch, arrow, right"
    }
  }, [_vm._v("ion-ios-play-outline")]), _c('li', {
    staticClass: "ion-ios-pause",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, break, hold, freeze"
    }
  }, [_vm._v("ion-ios-pause")]), _c('li', {
    staticClass: "ion-ios-pause-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, break, hold, freeze"
    }
  }, [_vm._v("ion-ios-pause-outline")]), _c('li', {
    staticClass: "ion-ios-recording",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, tape, voicemail"
    }
  }, [_vm._v("ion-ios-recording")]), _c('li', {
    staticClass: "ion-ios-recording-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, tape, voicemail"
    }
  }, [_vm._v("ion-ios-recording-outline")]), _c('li', {
    staticClass: "ion-ios-fastforward",
    attrs: {
      "data-pack": "ios",
      "data-tags": "next, skip, jump"
    }
  }, [_vm._v("ion-ios-fastforward")]), _c('li', {
    staticClass: "ion-ios-fastforward-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "next, skip, jump"
    }
  }, [_vm._v("ion-ios-fastforward-outline")]), _c('li', {
    staticClass: "ion-ios-rewind",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, previous, back"
    }
  }, [_vm._v("ion-ios-rewind")]), _c('li', {
    staticClass: "ion-ios-rewind-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, previous, back"
    }
  }, [_vm._v("ion-ios-rewind-outline")]), _c('li', {
    staticClass: "ion-ios-skipbackward",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, previous"
    }
  }, [_vm._v("ion-ios-skipbackward")]), _c('li', {
    staticClass: "ion-ios-skipbackward-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, previous"
    }
  }, [_vm._v("ion-ios-skipbackward-outline")]), _c('li', {
    staticClass: "ion-ios-skipforward",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, next"
    }
  }, [_vm._v("ion-ios-skipforward")]), _c('li', {
    staticClass: "ion-ios-skipforward-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, next"
    }
  }, [_vm._v("ion-ios-skipforward-outline")]), _c('li', {
    staticClass: "ion-ios-shuffle-strong",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, next"
    }
  }, [_vm._v("ion-ios-shuffle-strong")]), _c('li', {
    staticClass: "ion-ios-shuffle",
    attrs: {
      "data-pack": "ios",
      "data-tags": "music, next"
    }
  }, [_vm._v("ion-ios-shuffle")]), _c('li', {
    staticClass: "ion-ios-videocam",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, movie, camera"
    }
  }, [_vm._v("ion-ios-videocam")]), _c('li', {
    staticClass: "ion-ios-videocam-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, movie, camera"
    }
  }, [_vm._v("ion-ios-videocam-outline")]), _c('li', {
    staticClass: "ion-ios-film",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, movie, camera"
    }
  }, [_vm._v("ion-ios-film")]), _c('li', {
    staticClass: "ion-ios-film-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "film, movie, camera"
    }
  }, [_vm._v("ion-ios-film-outline")]), _c('li', {
    staticClass: "ion-ios-flask",
    attrs: {
      "data-pack": "ios",
      "data-tags": "options, mixer, liquid"
    }
  }, [_vm._v("ion-ios-flask")]), _c('li', {
    staticClass: "ion-ios-flask-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "options, mixer, liquid"
    }
  }, [_vm._v("ion-ios-flask-outline")]), _c('li', {
    staticClass: "ion-ios-lightbulb",
    attrs: {
      "data-pack": "ios",
      "data-tags": "idea, new, bright, aha!"
    }
  }, [_vm._v("ion-ios-lightbulb")]), _c('li', {
    staticClass: "ion-ios-lightbulb-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "idea, new, bright, aha!"
    }
  }, [_vm._v("ion-ios-lightbulb-outline")]), _c('li', {
    staticClass: "ion-ios-wineglass",
    attrs: {
      "data-pack": "ios",
      "data-tags": "alcohol, drink, food, glass, drunk, cheers"
    }
  }, [_vm._v("ion-ios-wineglass")]), _c('li', {
    staticClass: "ion-ios-wineglass-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "alcohol, drink, food, glass, drunk, cheers"
    }
  }, [_vm._v("ion-ios-wineglass-outline")]), _c('li', {
    staticClass: "ion-ios-pint",
    attrs: {
      "data-pack": "ios",
      "data-tags": "alcohol, drink, food, beer, drunk, cheers"
    }
  }, [_vm._v("ion-ios-pint")]), _c('li', {
    staticClass: "ion-ios-pint-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "alcohol, drink, food, beer, drunk, cheers"
    }
  }, [_vm._v("ion-ios-pint-outline")]), _c('li', {
    staticClass: "ion-ios-nutrition",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, carrot, food"
    }
  }, [_vm._v("ion-ios-nutrition")]), _c('li', {
    staticClass: "ion-ios-nutrition-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "health, carrot, food"
    }
  }, [_vm._v("ion-ios-nutrition-outline")]), _c('li', {
    staticClass: "ion-ios-flower",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, spring, leaf, garden"
    }
  }, [_vm._v("ion-ios-flower")]), _c('li', {
    staticClass: "ion-ios-flower-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, spring, leaf, garden"
    }
  }, [_vm._v("ion-ios-flower-outline")]), _c('li', {
    staticClass: "ion-ios-rose",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, spring, leaf, garden, flower"
    }
  }, [_vm._v("ion-ios-rose")]), _c('li', {
    staticClass: "ion-ios-rose-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, spring, leaf, garden, flower"
    }
  }, [_vm._v("ion-ios-rose-outline")]), _c('li', {
    staticClass: "ion-ios-paw",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, animal, pet, outdoor, track"
    }
  }, [_vm._v("ion-ios-paw")]), _c('li', {
    staticClass: "ion-ios-paw-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "nature, animal, pet, outdoor, track"
    }
  }, [_vm._v("ion-ios-paw-outline")]), _c('li', {
    staticClass: "ion-ios-flame",
    attrs: {
      "data-pack": "ios",
      "data-tags": "fire, hot, burn"
    }
  }, [_vm._v("ion-ios-flame")]), _c('li', {
    staticClass: "ion-ios-flame-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "fire, hot, burn"
    }
  }, [_vm._v("ion-ios-flame-outline")]), _c('li', {
    staticClass: "ion-ios-sunny",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, light, sky"
    }
  }, [_vm._v("ion-ios-sunny")]), _c('li', {
    staticClass: "ion-ios-sunny-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, light, sky"
    }
  }, [_vm._v("ion-ios-sunny-outline")]), _c('li', {
    staticClass: "ion-ios-partlysunny",
    attrs: {
      "data-pack": "ios",
      "data-tags": "light, weather, whether, cloudy"
    }
  }, [_vm._v("ion-ios-partlysunny")]), _c('li', {
    staticClass: "ion-ios-partlysunny-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "light, weather, whether, cloudy"
    }
  }, [_vm._v("ion-ios-partlysunny-outline")]), _c('li', {
    staticClass: "ion-ios-cloudy",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, overcast"
    }
  }, [_vm._v("ion-ios-cloudy")]), _c('li', {
    staticClass: "ion-ios-cloudy-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, overcast"
    }
  }, [_vm._v("ion-ios-cloudy-outline")]), _c('li', {
    staticClass: "ion-ios-rainy",
    attrs: {
      "data-pack": "ios",
      "data-tags": "whether, weather, water, cloud"
    }
  }, [_vm._v("ion-ios-rainy")]), _c('li', {
    staticClass: "ion-ios-rainy-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "whether, weather, water, cloud"
    }
  }, [_vm._v("ion-ios-rainy-outline")]), _c('li', {
    staticClass: "ion-ios-thunderstorm",
    attrs: {
      "data-pack": "ios",
      "data-tags": "whether, weather, sky, lightning, rain, cloudy, overcast, storm"
    }
  }, [_vm._v("ion-ios-thunderstorm")]), _c('li', {
    staticClass: "ion-ios-thunderstorm-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "whether, weather, sky, lightning, rain, cloudy, overcast, storm"
    }
  }, [_vm._v("ion-ios-thunderstorm-outline")]), _c('li', {
    staticClass: "ion-ios-snowy",
    attrs: {
      "data-pack": "ios",
      "data-tags": "cold, weather, whether, overcast"
    }
  }, [_vm._v("ion-ios-snowy")]), _c('li', {
    staticClass: "ion-ios-moon",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sky, night, dark"
    }
  }, [_vm._v("ion-ios-moon")]), _c('li', {
    staticClass: "ion-ios-moon-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "sky, night, dark"
    }
  }, [_vm._v("ion-ios-moon-outline")]), _c('li', {
    staticClass: "ion-ios-cloudy-night",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, overcast"
    }
  }, [_vm._v("ion-ios-cloudy-night")]), _c('li', {
    staticClass: "ion-ios-cloudy-night-outline",
    attrs: {
      "data-pack": "ios",
      "data-tags": "weather, whether, overcast"
    }
  }, [_vm._v("ion-ios-cloudy-night-outline")]), _c('p'), _c('li', {
    staticClass: "ion-android-arrow-up",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-up")]), _c('li', {
    staticClass: "ion-android-arrow-forward",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-forward")]), _c('li', {
    staticClass: "ion-android-arrow-down",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-down")]), _c('li', {
    staticClass: "ion-android-arrow-back",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-back")]), _c('li', {
    staticClass: "ion-android-arrow-dropup",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropup")]), _c('li', {
    staticClass: "ion-android-arrow-dropup-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropup-circle")]), _c('li', {
    staticClass: "ion-android-arrow-dropright",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropright")]), _c('li', {
    staticClass: "ion-android-arrow-dropright-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropright-circle")]), _c('li', {
    staticClass: "ion-android-arrow-dropdown",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropdown")]), _c('li', {
    staticClass: "ion-android-arrow-dropdown-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropdown-circle")]), _c('li', {
    staticClass: "ion-android-arrow-dropleft",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropleft")]), _c('li', {
    staticClass: "ion-android-arrow-dropleft-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "chevron, navigation"
    }
  }, [_vm._v("ion-android-arrow-dropleft-circle")]), _c('li', {
    staticClass: "ion-android-add",
    attrs: {
      "data-pack": "android",
      "data-tags": "plus, include, invite"
    }
  }, [_vm._v("ion-android-add")]), _c('li', {
    staticClass: "ion-android-add-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "plus, include, invite"
    }
  }, [_vm._v("ion-android-add-circle")]), _c('li', {
    staticClass: "ion-android-remove",
    attrs: {
      "data-pack": "android",
      "data-tags": "minus, subtract, delete"
    }
  }, [_vm._v("ion-android-remove")]), _c('li', {
    staticClass: "ion-android-remove-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": "minus, subtract, delete"
    }
  }, [_vm._v("ion-android-remove-circle")]), _c('li', {
    staticClass: "ion-android-close",
    attrs: {
      "data-pack": "android",
      "data-tags": "delete, remove"
    }
  }, [_vm._v("ion-android-close")]), _c('li', {
    staticClass: "ion-android-cancel",
    attrs: {
      "data-pack": "android",
      "data-tags": "delete, remove"
    }
  }, [_vm._v("ion-android-cancel")]), _c('li', {
    staticClass: "ion-android-radio-button-off",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-radio-button-off")]), _c('li', {
    staticClass: "ion-android-radio-button-on",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-radio-button-on")]), _c('li', {
    staticClass: "ion-android-checkmark-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-checkmark-circle")]), _c('li', {
    staticClass: "ion-android-checkbox-outline-blank",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-checkbox-outline-blank")]), _c('li', {
    staticClass: "ion-android-checkbox-outline",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-checkbox-outline")]), _c('li', {
    staticClass: "ion-android-checkbox-blank",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-checkbox-blank")]), _c('li', {
    staticClass: "ion-android-checkbox",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-checkbox")]), _c('li', {
    staticClass: "ion-android-done",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-done")]), _c('li', {
    staticClass: "ion-android-done-all",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-done-all")]), _c('li', {
    staticClass: "ion-android-menu",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-menu")]), _c('li', {
    staticClass: "ion-android-more-horizontal",
    attrs: {
      "data-pack": "android",
      "data-tags": "options, menu"
    }
  }, [_vm._v("ion-android-more-horizontal")]), _c('li', {
    staticClass: "ion-android-more-vertical",
    attrs: {
      "data-pack": "android",
      "data-tags": "options, menu"
    }
  }, [_vm._v("ion-android-more-vertical")]), _c('li', {
    staticClass: "ion-android-refresh",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-refresh")]), _c('li', {
    staticClass: "ion-android-sync",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-sync")]), _c('li', {
    staticClass: "ion-android-wifi",
    attrs: {
      "data-pack": "android",
      "data-tags": "internet,connection, bars"
    }
  }, [_vm._v("ion-android-wifi")]), _c('li', {
    staticClass: "ion-android-call",
    attrs: {
      "data-pack": "android",
      "data-tags": "telephone"
    }
  }, [_vm._v("ion-android-call")]), _c('li', {
    staticClass: "ion-android-apps",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-apps")]), _c('li', {
    staticClass: "ion-android-settings",
    attrs: {
      "data-pack": "android",
      "data-tags": "options"
    }
  }, [_vm._v("ion-android-settings")]), _c('li', {
    staticClass: "ion-android-options",
    attrs: {
      "data-pack": "android",
      "data-tags": "settings, mixer"
    }
  }, [_vm._v("ion-android-options")]), _c('li', {
    staticClass: "ion-android-funnel",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-funnel")]), _c('li', {
    staticClass: "ion-android-search",
    attrs: {
      "data-pack": "android",
      "data-tags": "magnifying glass"
    }
  }, [_vm._v("ion-android-search")]), _c('li', {
    staticClass: "ion-android-home",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-home")]), _c('li', {
    staticClass: "ion-android-cloud-outline",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-cloud-outline")]), _c('li', {
    staticClass: "ion-android-cloud",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-cloud")]), _c('li', {
    staticClass: "ion-android-download",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-download")]), _c('li', {
    staticClass: "ion-android-upload",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-upload")]), _c('li', {
    staticClass: "ion-android-cloud-done",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-cloud-done")]), _c('li', {
    staticClass: "ion-android-cloud-circle",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-cloud-circle")]), _c('li', {
    staticClass: "ion-android-favorite-outline",
    attrs: {
      "data-pack": "android",
      "data-tags": "favorite, like, rate"
    }
  }, [_vm._v("ion-android-favorite-outline")]), _c('li', {
    staticClass: "ion-android-favorite",
    attrs: {
      "data-pack": "android",
      "data-tags": "favorite, like, rate"
    }
  }, [_vm._v("ion-android-favorite")]), _c('li', {
    staticClass: "ion-android-star-outline",
    attrs: {
      "data-pack": "android",
      "data-tags": "favorite, like, rate"
    }
  }, [_vm._v("ion-android-star-outline")]), _c('li', {
    staticClass: "ion-android-star-half",
    attrs: {
      "data-pack": "android",
      "data-tags": "favorite, like, rate"
    }
  }, [_vm._v("ion-android-star-half")]), _c('li', {
    staticClass: "ion-android-star",
    attrs: {
      "data-pack": "android",
      "data-tags": "favorite, like, rate"
    }
  }, [_vm._v("ion-android-star")]), _c('li', {
    staticClass: "ion-android-calendar",
    attrs: {
      "data-pack": "android",
      "data-tags": "clock"
    }
  }, [_vm._v("ion-android-calendar")]), _c('li', {
    staticClass: "ion-android-alarm-clock",
    attrs: {
      "data-pack": "android",
      "data-tags": "clock"
    }
  }, [_vm._v("ion-android-alarm-clock")]), _c('li', {
    staticClass: "ion-android-time",
    attrs: {
      "data-pack": "android",
      "data-tags": "clock"
    }
  }, [_vm._v("ion-android-time")]), _c('li', {
    staticClass: "ion-android-stopwatch",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-stopwatch")]), _c('li', {
    staticClass: "ion-android-watch",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-watch")]), _c('li', {
    staticClass: "ion-android-locate",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-locate")]), _c('li', {
    staticClass: "ion-android-navigate",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-navigate")]), _c('li', {
    staticClass: "ion-android-pin",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-pin")]), _c('li', {
    staticClass: "ion-android-compass",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-compass")]), _c('li', {
    staticClass: "ion-android-map",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-map")]), _c('li', {
    staticClass: "ion-android-walk",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-walk")]), _c('li', {
    staticClass: "ion-android-bicycle",
    attrs: {
      "data-pack": "android",
      "data-tags": "move, bike, transportation, maps"
    }
  }, [_vm._v("ion-android-bicycle")]), _c('li', {
    staticClass: "ion-android-car",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-car")]), _c('li', {
    staticClass: "ion-android-bus",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-bus")]), _c('li', {
    staticClass: "ion-android-subway",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-subway")]), _c('li', {
    staticClass: "ion-android-train",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-train")]), _c('li', {
    staticClass: "ion-android-boat",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-boat")]), _c('li', {
    staticClass: "ion-android-plane",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-plane")]), _c('li', {
    staticClass: "ion-android-restaurant",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-restaurant")]), _c('li', {
    staticClass: "ion-android-bar",
    attrs: {
      "data-pack": "android",
      "data-tags": "wine, drink, food, dinner"
    }
  }, [_vm._v("ion-android-bar")]), _c('li', {
    staticClass: "ion-android-cart",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-cart")]), _c('li', {
    staticClass: "ion-android-camera",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-camera")]), _c('li', {
    staticClass: "ion-android-image",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-image")]), _c('li', {
    staticClass: "ion-android-film",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-film")]), _c('li', {
    staticClass: "ion-android-color-palette",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-color-palette")]), _c('li', {
    staticClass: "ion-android-create",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-create")]), _c('li', {
    staticClass: "ion-android-mail",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-mail")]), _c('li', {
    staticClass: "ion-android-drafts",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-drafts")]), _c('li', {
    staticClass: "ion-android-send",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-send")]), _c('li', {
    staticClass: "ion-android-archive",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-archive")]), _c('li', {
    staticClass: "ion-android-delete",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-delete")]), _c('li', {
    staticClass: "ion-android-attach",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-attach")]), _c('li', {
    staticClass: "ion-android-share",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-share")]), _c('li', {
    staticClass: "ion-android-share-alt",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-share-alt")]), _c('li', {
    staticClass: "ion-android-bookmark",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-bookmark")]), _c('li', {
    staticClass: "ion-android-document",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-document")]), _c('li', {
    staticClass: "ion-android-clipboard",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-clipboard")]), _c('li', {
    staticClass: "ion-android-list",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-list")]), _c('li', {
    staticClass: "ion-android-folder-open",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-folder-open")]), _c('li', {
    staticClass: "ion-android-folder",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-folder")]), _c('li', {
    staticClass: "ion-android-print",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-print")]), _c('li', {
    staticClass: "ion-android-open",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-open")]), _c('li', {
    staticClass: "ion-android-exit",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-exit")]), _c('li', {
    staticClass: "ion-android-contract",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-contract")]), _c('li', {
    staticClass: "ion-android-expand",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-expand")]), _c('li', {
    staticClass: "ion-android-globe",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-globe")]), _c('li', {
    staticClass: "ion-android-chat",
    attrs: {
      "data-pack": "android",
      "data-tags": "talk, text"
    }
  }, [_vm._v("ion-android-chat")]), _c('li', {
    staticClass: "ion-android-textsms",
    attrs: {
      "data-pack": "android",
      "data-tags": "talk, text"
    }
  }, [_vm._v("ion-android-textsms")]), _c('li', {
    staticClass: "ion-android-hangout",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-hangout")]), _c('li', {
    staticClass: "ion-android-happy",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-happy")]), _c('li', {
    staticClass: "ion-android-sad",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-sad")]), _c('li', {
    staticClass: "ion-android-person",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-person")]), _c('li', {
    staticClass: "ion-android-people",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-people")]), _c('li', {
    staticClass: "ion-android-person-add",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-person-add")]), _c('li', {
    staticClass: "ion-android-contact",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-contact")]), _c('li', {
    staticClass: "ion-android-contacts",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-contacts")]), _c('li', {
    staticClass: "ion-android-playstore",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-playstore")]), _c('li', {
    staticClass: "ion-android-lock",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-lock")]), _c('li', {
    staticClass: "ion-android-unlock",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-unlock")]), _c('li', {
    staticClass: "ion-android-microphone",
    attrs: {
      "data-pack": "android",
      "data-tags": "recorder, speak, noise, music, sound"
    }
  }, [_vm._v("ion-android-microphone")]), _c('li', {
    staticClass: "ion-android-microphone-off",
    attrs: {
      "data-pack": "android",
      "data-tags": "recorder, speak, noise, music, sound, mute"
    }
  }, [_vm._v("ion-android-microphone-off")]), _c('li', {
    staticClass: "ion-android-notifications-none",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-notifications-none")]), _c('li', {
    staticClass: "ion-android-notifications",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-notifications")]), _c('li', {
    staticClass: "ion-android-notifications-off",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-notifications-off")]), _c('li', {
    staticClass: "ion-android-volume-mute",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-volume-mute")]), _c('li', {
    staticClass: "ion-android-volume-down",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-volume-down")]), _c('li', {
    staticClass: "ion-android-volume-up",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-volume-up")]), _c('li', {
    staticClass: "ion-android-volume-off",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-volume-off")]), _c('li', {
    staticClass: "ion-android-hand",
    attrs: {
      "data-pack": "android",
      "data-tags": "stop"
    }
  }, [_vm._v("ion-android-hand")]), _c('li', {
    staticClass: "ion-android-desktop",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-desktop")]), _c('li', {
    staticClass: "ion-android-laptop",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-laptop")]), _c('li', {
    staticClass: "ion-android-phone-portrait",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-phone-portrait")]), _c('li', {
    staticClass: "ion-android-phone-landscape",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-phone-landscape")]), _c('li', {
    staticClass: "ion-android-bulb",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-bulb")]), _c('li', {
    staticClass: "ion-android-sunny",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-sunny")]), _c('li', {
    staticClass: "ion-android-alert",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-alert")]), _c('li', {
    staticClass: "ion-android-warning",
    attrs: {
      "data-pack": "android",
      "data-tags": ""
    }
  }, [_vm._v("ion-android-warning")]), _c('p'), _c('li', {
    staticClass: "ion-social-twitter",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-twitter")]), _c('li', {
    staticClass: "ion-social-twitter-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-twitter-outline")]), _c('li', {
    staticClass: "ion-social-facebook",
    attrs: {
      "data-pack": "social",
      "data-tags": "like, post, share"
    }
  }, [_vm._v("ion-social-facebook")]), _c('li', {
    staticClass: "ion-social-facebook-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "like, post, share"
    }
  }, [_vm._v("ion-social-facebook-outline")]), _c('li', {
    staticClass: "ion-social-googleplus",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-googleplus")]), _c('li', {
    staticClass: "ion-social-googleplus-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-googleplus-outline")]), _c('li', {
    staticClass: "ion-social-google",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-google")]), _c('li', {
    staticClass: "ion-social-google-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "follow, post, share"
    }
  }, [_vm._v("ion-social-google-outline")]), _c('li', {
    staticClass: "ion-social-dribbble",
    attrs: {
      "data-pack": "social",
      "data-tags": "design"
    }
  }, [_vm._v("ion-social-dribbble")]), _c('li', {
    staticClass: "ion-social-dribbble-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "design"
    }
  }, [_vm._v("ion-social-dribbble-outline")]), _c('li', {
    staticClass: "ion-social-octocat",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, github, fork, merge, clone"
    }
  }, [_vm._v("ion-social-octocat")]), _c('li', {
    staticClass: "ion-social-github",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, fork, merge, clone"
    }
  }, [_vm._v("ion-social-github")]), _c('li', {
    staticClass: "ion-social-github-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, fork, merge, clone"
    }
  }, [_vm._v("ion-social-github-outline")]), _c('li', {
    staticClass: "ion-social-instagram",
    attrs: {
      "data-pack": "social",
      "data-tags": "photo, camera, facebook"
    }
  }, [_vm._v("ion-social-instagram")]), _c('li', {
    staticClass: "ion-social-instagram-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "photo, camera, facebook"
    }
  }, [_vm._v("ion-social-instagram-outline")]), _c('li', {
    staticClass: "ion-social-whatsapp",
    attrs: {
      "data-pack": "social",
      "data-tags": "text, sharing, private, facebook"
    }
  }, [_vm._v("ion-social-whatsapp")]), _c('li', {
    staticClass: "ion-social-whatsapp-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "text, sharing, private, facebook"
    }
  }, [_vm._v("ion-social-whatsapp-outline")]), _c('li', {
    staticClass: "ion-social-snapchat",
    attrs: {
      "data-pack": "social",
      "data-tags": "photos, app"
    }
  }, [_vm._v("ion-social-snapchat")]), _c('li', {
    staticClass: "ion-social-snapchat-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "photos, app"
    }
  }, [_vm._v("ion-social-snapchat-outline")]), _c('li', {
    staticClass: "ion-social-foursquare",
    attrs: {
      "data-pack": "social",
      "data-tags": "checkin"
    }
  }, [_vm._v("ion-social-foursquare")]), _c('li', {
    staticClass: "ion-social-foursquare-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "checkin"
    }
  }, [_vm._v("ion-social-foursquare-outline")]), _c('li', {
    staticClass: "ion-social-pinterest",
    attrs: {
      "data-pack": "social",
      "data-tags": "social"
    }
  }, [_vm._v("ion-social-pinterest")]), _c('li', {
    staticClass: "ion-social-pinterest-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "social"
    }
  }, [_vm._v("ion-social-pinterest-outline")]), _c('li', {
    staticClass: "ion-social-rss",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-rss")]), _c('li', {
    staticClass: "ion-social-rss-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-rss-outline")]), _c('li', {
    staticClass: "ion-social-tumblr",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-tumblr")]), _c('li', {
    staticClass: "ion-social-tumblr-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-tumblr-outline")]), _c('li', {
    staticClass: "ion-social-wordpress",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-wordpress")]), _c('li', {
    staticClass: "ion-social-wordpress-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "blogging"
    }
  }, [_vm._v("ion-social-wordpress-outline")]), _c('li', {
    staticClass: "ion-social-reddit",
    attrs: {
      "data-pack": "social",
      "data-tags": "news, upvotes, karma"
    }
  }, [_vm._v("ion-social-reddit")]), _c('li', {
    staticClass: "ion-social-reddit-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "news, upvotes, karma"
    }
  }, [_vm._v("ion-social-reddit-outline")]), _c('li', {
    staticClass: "ion-social-hackernews",
    attrs: {
      "data-pack": "social",
      "data-tags": "discuss, upvotes, karma"
    }
  }, [_vm._v("ion-social-hackernews")]), _c('li', {
    staticClass: "ion-social-hackernews-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "discuss, upvotes, karma"
    }
  }, [_vm._v("ion-social-hackernews-outline")]), _c('li', {
    staticClass: "ion-social-designernews",
    attrs: {
      "data-pack": "social",
      "data-tags": "design, post"
    }
  }, [_vm._v("ion-social-designernews")]), _c('li', {
    staticClass: "ion-social-designernews-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "design, post"
    }
  }, [_vm._v("ion-social-designernews-outline")]), _c('li', {
    staticClass: "ion-social-yahoo",
    attrs: {
      "data-pack": "social",
      "data-tags": ""
    }
  }, [_vm._v("ion-social-yahoo")]), _c('li', {
    staticClass: "ion-social-yahoo-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": ""
    }
  }, [_vm._v("ion-social-yahoo-outline")]), _c('li', {
    staticClass: "ion-social-buffer",
    attrs: {
      "data-pack": "social",
      "data-tags": "share"
    }
  }, [_vm._v("ion-social-buffer")]), _c('li', {
    staticClass: "ion-social-buffer-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "share"
    }
  }, [_vm._v("ion-social-buffer-outline")]), _c('li', {
    staticClass: "ion-social-skype",
    attrs: {
      "data-pack": "social",
      "data-tags": "call"
    }
  }, [_vm._v("ion-social-skype")]), _c('li', {
    staticClass: "ion-social-skype-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "call"
    }
  }, [_vm._v("ion-social-skype-outline")]), _c('li', {
    staticClass: "ion-social-linkedin",
    attrs: {
      "data-pack": "social",
      "data-tags": "connect"
    }
  }, [_vm._v("ion-social-linkedin")]), _c('li', {
    staticClass: "ion-social-linkedin-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "connect"
    }
  }, [_vm._v("ion-social-linkedin-outline")]), _c('li', {
    staticClass: "ion-social-vimeo",
    attrs: {
      "data-pack": "social",
      "data-tags": "video, watch, share, view"
    }
  }, [_vm._v("ion-social-vimeo")]), _c('li', {
    staticClass: "ion-social-vimeo-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "video, watch, share, view"
    }
  }, [_vm._v("ion-social-vimeo-outline")]), _c('li', {
    staticClass: "ion-social-twitch",
    attrs: {
      "data-pack": "social",
      "data-tags": "gaming, games, live, streaming, video, watch, share, view"
    }
  }, [_vm._v("ion-social-twitch")]), _c('li', {
    staticClass: "ion-social-twitch-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "gaming, games, live, streaming, video, watch, share, view"
    }
  }, [_vm._v("ion-social-twitch-outline")]), _c('li', {
    staticClass: "ion-social-youtube",
    attrs: {
      "data-pack": "social",
      "data-tags": "video, watch, share, view"
    }
  }, [_vm._v("ion-social-youtube")]), _c('li', {
    staticClass: "ion-social-youtube-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "video, watch, share, view"
    }
  }, [_vm._v("ion-social-youtube-outline")]), _c('li', {
    staticClass: "ion-social-dropbox",
    attrs: {
      "data-pack": "social",
      "data-tags": "upload"
    }
  }, [_vm._v("ion-social-dropbox")]), _c('li', {
    staticClass: "ion-social-dropbox-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "upload"
    }
  }, [_vm._v("ion-social-dropbox-outline")]), _c('li', {
    staticClass: "ion-social-apple",
    attrs: {
      "data-pack": "social",
      "data-tags": "mac, mobile"
    }
  }, [_vm._v("ion-social-apple")]), _c('li', {
    staticClass: "ion-social-apple-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "mac, mobile"
    }
  }, [_vm._v("ion-social-apple-outline")]), _c('li', {
    staticClass: "ion-social-android",
    attrs: {
      "data-pack": "social",
      "data-tags": "mobile"
    }
  }, [_vm._v("ion-social-android")]), _c('li', {
    staticClass: "ion-social-android-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "mobile"
    }
  }, [_vm._v("ion-social-android-outline")]), _c('li', {
    staticClass: "ion-social-windows",
    attrs: {
      "data-pack": "social",
      "data-tags": "pc"
    }
  }, [_vm._v("ion-social-windows")]), _c('li', {
    staticClass: "ion-social-windows-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "pc"
    }
  }, [_vm._v("ion-social-windows-outline")]), _c('li', {
    staticClass: "ion-social-html5",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-html5")]), _c('li', {
    staticClass: "ion-social-html5-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-html5-outline")]), _c('li', {
    staticClass: "ion-social-css3",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-css3")]), _c('li', {
    staticClass: "ion-social-css3-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-css3-outline")]), _c('li', {
    staticClass: "ion-social-javascript",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-javascript")]), _c('li', {
    staticClass: "ion-social-javascript-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, html, css, js, developer"
    }
  }, [_vm._v("ion-social-javascript-outline")]), _c('li', {
    staticClass: "ion-social-angular",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, mobile, js, angularjs, ionic"
    }
  }, [_vm._v("ion-social-angular")]), _c('li', {
    staticClass: "ion-social-angular-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, mobile, js, angularjs, ionic"
    }
  }, [_vm._v("ion-social-angular-outline")]), _c('li', {
    staticClass: "ion-social-nodejs",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, js, javascript, developer"
    }
  }, [_vm._v("ion-social-nodejs")]), _c('li', {
    staticClass: "ion-social-sass",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, css"
    }
  }, [_vm._v("ion-social-sass")]), _c('li', {
    staticClass: "ion-social-python",
    attrs: {
      "data-pack": "social",
      "data-tags": "code"
    }
  }, [_vm._v("ion-social-python")]), _c('li', {
    staticClass: "ion-social-chrome",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, mobile, js, angularjs, ionic"
    }
  }, [_vm._v("ion-social-chrome")]), _c('li', {
    staticClass: "ion-social-chrome-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, mobile, js, angularjs, ionic"
    }
  }, [_vm._v("ion-social-chrome-outline")]), _c('li', {
    staticClass: "ion-social-codepen",
    attrs: {
      "data-pack": "social",
      "data-tags": "testing, js, developer"
    }
  }, [_vm._v("ion-social-codepen")]), _c('li', {
    staticClass: "ion-social-codepen-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "testing, js, developer"
    }
  }, [_vm._v("ion-social-codepen-outline")]), _c('li', {
    staticClass: "ion-social-markdown",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, testing, text, developer"
    }
  }, [_vm._v("ion-social-markdown")]), _c('li', {
    staticClass: "ion-social-tux",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, linux, opensource"
    }
  }, [_vm._v("ion-social-tux")]), _c('li', {
    staticClass: "ion-social-freebsd-devil",
    attrs: {
      "data-pack": "social",
      "data-tags": "code, opensource, unix"
    }
  }, [_vm._v("ion-social-freebsd-devil")]), _c('li', {
    staticClass: "ion-social-usd",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, cash"
    }
  }, [_vm._v("ion-social-usd")]), _c('li', {
    staticClass: "ion-social-usd-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, cash"
    }
  }, [_vm._v("ion-social-usd-outline")]), _c('li', {
    staticClass: "ion-social-bitcoin",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money"
    }
  }, [_vm._v("ion-social-bitcoin")]), _c('li', {
    staticClass: "ion-social-bitcoin-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money"
    }
  }, [_vm._v("ion-social-bitcoin-outline")]), _c('li', {
    staticClass: "ion-social-yen",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, japanese"
    }
  }, [_vm._v("ion-social-yen")]), _c('li', {
    staticClass: "ion-social-yen-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, japanese"
    }
  }, [_vm._v("ion-social-yen-outline")]), _c('li', {
    staticClass: "ion-social-euro",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, europe"
    }
  }, [_vm._v("ion-social-euro")]), _c('li', {
    staticClass: "ion-social-euro-outline",
    attrs: {
      "data-pack": "social",
      "data-tags": "currency, trade, money, europe"
    }
  }, [_vm._v("ion-social-euro-outline")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d8edfba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblIcon/example/allIcons.vue
// module id = 244
// module chunks = 0